/* tp-story v1 - "Fă un video pentru Story" pe pagina de produs (TotalPantofi.ro)
 *
 * Genereaza IN BROWSER (fara server) un video vertical 9:16 cu produsul (poze, nume, pret, marimi, muzica) si il da spre
 * Story / Facebook / Instagram / WhatsApp. Oricine il poate face, fara cont.
 *
 * Lant de siguranta (prima varianta care merge):
 *   1. WebCodecs (VideoEncoder H.264 + AudioEncoder AAC) + mp4-muxer  -> MP4 real, rapid (mai repede decat timpul real)
 *   2. MediaRecorder pe canvas.captureStream                          -> MP4/WebM in timp real
 *   3. Poza (PNG 9:16) cu acelasi design                              -> daca browserul nu poate video deloc
 * Distribuire: Web Share cu fisier (telefon: Story/Facebook/Instagram/WhatsApp) | salvare + Facebook Stories / sharer (PC).
 *
 * Opriri: ?tps_story=0  sau  localStorage tps_story_off=1  sau  window.TPS_STORY_DISABLED = true.
 * Fisiere lazy (doar la click): tp-story-mux.js, tp-story-brico-latin.woff2, tp-story-brico-ext.woff2.
 */
(function () {
  'use strict';

  var VERSION = 'v1';
  if (window.__tpStory) return;
  try {
    if (window.TPS_STORY_DISABLED || /[?&]tps_story=0(&|$)/.test(location.search) || localStorage.getItem('tps_story_off') === '1') return;
  } catch (e) {}
  if (!/\/products\/[^\/?#]+/.test(location.pathname)) return;
  window.__tpStory = VERSION;

  var SCRIPT_SRC = '';
  try { SCRIPT_SRC = (document.currentScript && document.currentScript.src) || ''; } catch (e) {}
  if (!SCRIPT_SRC) {
    var ss = document.getElementsByTagName('script');
    for (var si = 0; si < ss.length; si++) if (/tp-story\.js/.test(ss[si].src)) SCRIPT_SRC = ss[si].src;
  }
  function assetUrl(name) { try { return new URL(name, SCRIPT_SRC || location.href).href; } catch (e) { return name; } }

  var DEBUG = /[?&]tps_debug=1(&|$)/.test(location.search);
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[tp-story]'].concat([].slice.call(arguments))); }

  /* ------------------------------------------------------------------ constante */
  var STORE = 'TotalPantofi.ro';
  var W = 1080, H = 1920, FPS = 30;
  var FONT = 'TPS Brico';
  var FONT_STACK = '"' + FONT + '", "Bricolage Grotesque", system-ui, "Segoe UI", Roboto, Arial, sans-serif';
  var SHOT = 1.8;            // o poza = o masura (4 timpi la 133 BPM) -> muzica se aliniaza cu schimbarile de poza
  var OUTRO = 2.8;
  
  var PALETTES = [
    { id: 'orange', name: 'Portocaliu', c1: '#ff8a1f', c2: '#ff4f9a', blob: 'rgba(255,255,255,0.20)', accent: '#ffe27a', ink: '#1b1b1f', pill: '#ffffff', badge: '#e11d48', badgeInk: '#ffffff', cta: '#ffffff', ctaInk: '#1b1b1f', ctaArrow: '#ff4f9a', conf: ['#ffffff', '#ffe27a', '#ffb3d1', '#ffd0a3'] },
    { id: 'night', name: 'Noapte', c1: '#160b2e', c2: '#5a1f78', blob: 'rgba(255,138,31,0.26)', accent: '#ffb347', ink: '#1b1b1f', pill: '#ffffff', badge: '#ff8a1f', badgeInk: '#1b1b1f', cta: '#ff8a1f', ctaInk: '#1b1b1f', ctaArrow: '#ffffff', conf: ['#ff8a1f', '#ff4f9a', '#ffe27a', '#ffffff'] },
    { id: 'sea', name: 'Turcoaz', c1: '#13b3a3', c2: '#1f6fe6', blob: 'rgba(255,255,255,0.20)', accent: '#ffe27a', ink: '#12202b', pill: '#ffffff', badge: '#ff4f5e', badgeInk: '#ffffff', cta: '#ffffff', ctaInk: '#12202b', ctaArrow: '#1f6fe6', conf: ['#ffffff', '#ffe27a', '#9ff3e9', '#a8c8ff'] }
  ];

  var UA = navigator.userAgent || '';
  var IN_APP = /FBAN|FBAV|FB_IAB|Instagram|MicroMessenger|Snapchat|TikTok|musical_ly/i.test(UA);
  var IS_MOBILE = /Android|iPhone|iPad|iPod|Mobile/i.test(UA) || (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.platform || ''));
  var LOW_END = (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4) || (navigator.deviceMemory && navigator.deviceMemory < 4);
  // 1080x1920 pe PC; 720x1280 pe telefon / device slab (aceeasi compozitie, mai putine pixeli de codat)
  var SCALE = (IS_MOBILE || LOW_END) ? 2 / 3 : 1;
  var PW = Math.round(W * SCALE), PH = Math.round(H * SCALE);

  /* ------------------------------------------------------------------ utilitare */
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function T(t, a, b) { return clamp01((t - a) / (b - a)); }
  function eOutCubic(t) { t = clamp01(t); return 1 - Math.pow(1 - t, 3); }
  function eInOutCubic(t) { t = clamp01(t); return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function eOutBack(t) { t = clamp01(t); var s = 1.70158, u = t - 1; return 1 + (s + 1) * u * u * u + s * u * u; }
  function eOutQuad(t) { t = clamp01(t); return 1 - (1 - t) * (1 - t); }
  function lerp(a, b, p) { return a + (b - a) * p; }
  function rng(seed) { var a = seed >>> 0; return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  var _mc = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null, _mq = [];
  if (_mc) _mc.port1.onmessage = function () { var f = _mq.shift(); if (f) f(); };
  function tick() { return new Promise(function (r) { if (_mc) { _mq.push(r); _mc.port2.postMessage(0); } else setTimeout(r, 0); }); }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function rrect(c, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
  }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params || {})); } catch (e) {}
  }

  /* ------------------------------------------------------------------ date produs */
  function handleFromPath() { var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function fmtPrice(cents) { var v = cents / 100; return (Math.round(v) === v) ? String(v) : v.toFixed(2).replace('.', ','); }

  function sizedUrl(u, width) {
    if (!u) return u;
    if (u.indexOf('//') === 0) u = 'https:' + u;
    var m = u.match(/^https?:\/\/cdn\.shopify\.com\/s\/files\/1\/\d+\/\d+\/\d+\/(.+)$/);
    var same = m ? '/cdn/shop/' + m[1] : u;
    return same + (same.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  async function loadProduct() {
    var handle = handleFromPath();
    var base = location.pathname.replace(/\/products\/.*$/, '');
    var r = await fetch(base + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('product-' + r.status);
    var p = await r.json();
    var variants = (p.variants || []).slice();
    var avail = variants.filter(function (v) { return v.available; });
    var pool = avail.length ? avail : variants;
    var pv = pool.slice().sort(function (a, b) { return a.price - b.price; })[0] || {};
    var price = pv.price != null ? pv.price : p.price;
    var cmp = pv.compare_at_price || p.compare_at_price || 0;
    var sizeIdx = -1;
    (p.options || []).forEach(function (o, i) { if (/size|m[ăa]rime|num[ăa]r|marime/i.test(o.name || '')) sizeIdx = i; });
    var sizes = [], seen = {};
    if (sizeIdx >= 0) avail.forEach(function (v) { var s = (v.options || [])[sizeIdx]; if (s && !/default title/i.test(s) && !seen[s]) { seen[s] = 1; sizes.push(String(s)); } });
    sizes.sort(function (a, b) { return parseFloat(a.replace(',', '.')) - parseFloat(b.replace(',', '.')); });
    var imgs = [];
    (p.images || []).forEach(function (u) { if (u && imgs.indexOf(u) < 0) imgs.push(u); });
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var url = location.origin + base + '/products/' + encodeURIComponent(handle);
    return {
      handle: handle, title: p.title || '', vendor: p.vendor || '', url: url,
      price: price, cmp: cmp > price ? cmp : 0, pct: cmp > price ? Math.round((1 - price / cmp) * 100) : 0,
      sizes: sizes, images: imgs, isNew: tags.indexOf('noutati') >= 0 || tags.indexOf('nou') >= 0, available: avail.length > 0
    };
  }

  function shareUrl(d, src) { return d.url + '?utm_source=' + (src || 'story') + '&utm_medium=social&utm_campaign=video_share'; }

  /* ------------------------------------------------------------------ resurse: fonturi, imagini, logo */
  var _fontP = null;
  function loadFonts() {
    if (_fontP) return _fontP;
    _fontP = (async function () {
      try {
        var faces = [
          new FontFace(FONT, 'url(' + assetUrl('tp-story-brico-latin.woff2') + ') format("woff2")', { weight: '200 800', unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD' }),
          new FontFace(FONT, 'url(' + assetUrl('tp-story-brico-ext.woff2') + ') format("woff2")', { weight: '200 800', unicodeRange: 'U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C4, U+2113, U+2C60-2C7F, U+A720-A7FF' })
        ];
        await Promise.all(faces.map(function (f) { return f.load(); }));
        faces.forEach(function (f) { document.fonts.add(f); });
        await document.fonts.load('800 60px "' + FONT + '"', 'Ăăâîșț');
        await document.fonts.load('500 40px "' + FONT + '"', 'Ăăâîșț');
        return true;
      } catch (e) { log('font', e); return false; }
    })();
    return _fontP;
  }

  function loadImage(url, timeout) {
    return new Promise(function (resolve) {
      var im = new Image(), done = false;
      function fin(ok) { if (done) return; done = true; clearTimeout(tm); resolve(ok ? im : null); }
      var tm = setTimeout(function () { fin(false); }, timeout || 15000);
      im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () { (im.decode ? im.decode().catch(function () {}) : Promise.resolve()).then(function () { fin(im.naturalWidth > 0); }); };
      im.onerror = function () { fin(false); };
      im.src = url;
    });
  }
  async function loadImageAny(u, width) {
    var a = await loadImage(sizedUrl(u, width));
    if (a) return a;
    var raw = u.indexOf('//') === 0 ? 'https:' + u : u;
    return await loadImage(raw + (raw.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width);
  }

  function findLogoUrl() {
    var cands = document.querySelectorAll('.header__heading-logo-wrapper img, .header__heading-logo img, header a[href="/"] img, header img');
    for (var i = 0; i < cands.length; i++) {
      var s = cands[i].currentSrc || cands[i].src;
      if (s && /logo/i.test(s)) return s;
    }
    return cands.length ? (cands[0].currentSrc || cands[0].src) : '';
  }

  // culoarea de fond a pozei (media marginilor) + daca fondul e uniform (poza de produs pe fond alb) sau nu (poza ambientala)
  function analyseImage(im) {
    var c = document.createElement('canvas'), n = 28; c.width = n; c.height = n;
    var x = c.getContext('2d', { willReadFrequently: true });
    try {
      x.drawImage(im, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data, px = [];
      for (var i = 0; i < n; i++) { px.push([i, 0], [i, n - 1], [0, i], [n - 1, i]); }
      var r = 0, g = 0, b = 0, a = 0, k = px.length;
      px.forEach(function (p) { var o = (p[1] * n + p[0]) * 4; r += d[o]; g += d[o + 1]; b += d[o + 2]; a += d[o + 3]; });
      r /= k; g /= k; b /= k; a /= k;
      var dev = 0;
      px.forEach(function (p) { var o = (p[1] * n + p[0]) * 4; dev += Math.abs(d[o] - r) + Math.abs(d[o + 1] - g) + Math.abs(d[o + 2] - b); });
      dev /= (k * 3);
      if (a < 40) return { rgb: [255, 255, 255], uniform: true };
      return { rgb: [Math.round(r), Math.round(g), Math.round(b)], uniform: dev < 14 };
    } catch (e) { return { rgb: [255, 255, 255], uniform: true }; }
  }

  // poza de produs pe fond uniform: marginile se topesc in culoarea fondului cardului (fara "cusatura" vizibila)
  // decupeaza marginile goale ale unei poze de produs pe fond uniform (produsul ramane intreg, doar mai mare in card)
  function trimToSubject(im, rgb) {
    try {
      var iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
      var sw = 180, sh = Math.max(40, Math.round(sw * ih / iw));
      var c = document.createElement('canvas'); c.width = sw; c.height = sh;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, sw, sh);
      var d = x.getImageData(0, 0, sw, sh).data, minx = sw, miny = sh, maxx = -1, maxy = -1;
      for (var yy = 0; yy < sh; yy++) for (var xx = 0; xx < sw; xx++) {
        var o = (yy * sw + xx) * 4;
        if (d[o + 3] < 40) continue;
        if (Math.abs(d[o] - rgb[0]) + Math.abs(d[o + 1] - rgb[1]) + Math.abs(d[o + 2] - rgb[2]) > 70) {
          if (xx < minx) minx = xx; if (xx > maxx) maxx = xx; if (yy < miny) miny = yy; if (yy > maxy) maxy = yy;
        }
      }
      if (maxx < 0) return im;
      var m = Math.round(0.07 * Math.max(maxx - minx, maxy - miny)) + 3;
      minx = Math.max(0, minx - m); miny = Math.max(0, miny - m); maxx = Math.min(sw - 1, maxx + m); maxy = Math.min(sh - 1, maxy + m);
      var k = iw / sw, sx = Math.floor(minx * k), sy = Math.floor(miny * k), cw = Math.ceil((maxx - minx + 1) * k), ch = Math.ceil((maxy - miny + 1) * k);
      cw = Math.min(cw, iw - sx); ch = Math.min(ch, ih - sy);
      if (cw * ch > 0.86 * iw * ih || cw < 200 || ch < 200) return im;       // nimic de decupat
      var out = document.createElement('canvas'), f = Math.min(1, 1500 / Math.max(cw, ch));
      out.width = Math.round(cw * f); out.height = Math.round(ch * f);
      var ox = out.getContext('2d'); ox.imageSmoothingQuality = 'high'; ox.fillStyle = 'rgb(' + rgb.join(',') + ')'; ox.fillRect(0, 0, out.width, out.height);
      ox.drawImage(im, sx, sy, cw, ch, 0, 0, out.width, out.height);
      return out;
    } catch (e) { return im; }
  }
  // fundal estompat din poza insasi (esantion foarte mic, marit cu netezire): umple cardul fara sa taie poza principala
  function makeBackdrop(im) {
    var iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
    var w = 40, h = Math.max(16, Math.min(120, Math.round(40 * ih / iw)));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(im, 0, 0, w, h);
    return c;
  }
  function featherImage(im, rgb) {
    var w = im.naturalWidth || im.width, h = im.naturalHeight || im.height;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d');
    var solid = 'rgb(' + rgb.join(',') + ')', clear = 'rgba(' + rgb.join(',') + ',0)';
    x.fillStyle = solid; x.fillRect(0, 0, w, h); x.drawImage(im, 0, 0);
    var f = Math.round(Math.min(w, h) * 0.05), g;
    function edge(x0, y0, x1, y1, rx, ry, rw, rh) { g = x.createLinearGradient(x0, y0, x1, y1); g.addColorStop(0, solid); g.addColorStop(1, clear); x.fillStyle = g; x.fillRect(rx, ry, rw, rh); }
    edge(0, 0, 0, f, 0, 0, w, f); edge(0, h, 0, h - f, 0, h - f, w, f); edge(0, 0, f, 0, 0, 0, f, h); edge(w, 0, w - f, 0, w - f, 0, f, h);
    return c;
  }

  /* ------------------------------------------------------------------ scena: deseneaza cadrul la momentul t */
  function Scene(o) {
    var d = o.data, pal = o.pal, logo = o.logo;
    var shots = o.shots;                // [{img, bg, uniform, backdrop}]
    var N = shots.length;
    // aranjare: poze pe inaltime (genti, ambient portret) => card inalt (poza apare ENTREGA, nu se mai taie); altfel card lat
    var asp = shots.map(function (sh) { var im0 = sh.img; return (im0.naturalWidth || im0.width) / (im0.naturalHeight || im0.height); }).sort(function (a, b) { return a - b; });
    var TALL = asp[Math.floor(asp.length / 2)] < 0.9;
    var CW = TALL ? 820 : 940, CH = TALL ? 1000 : 720, CCX = 540, CCY = TALL ? 738 : 605;   // cardul foto (spatiul 1080x1920)
    var CB = CCY + CH / 2;                                                                    // marginea de jos a cardului
    var OUT_SC = Math.min(0.7, 480 / CH), OUT_CY = 500;                                       // cardul in final: mai mic, sus
    var tOut = o.tOut || N * SHOT, D = tOut + (o.outroLen || OUTRO);
    var rand = rng(1234567);

    // elemente decorative deterministe
    var bokeh = [];
    for (var i = 0; i < 26; i++) bokeh.push({ x: rand() * W, y0: rand() * (H + 300), v: 22 + rand() * 60, r: 14 + rand() * 46, a: 0.05 + rand() * 0.12, f: 0.3 + rand() * 0.8, ph: rand() * 6.28 });
    var conf = [];
    for (i = 0; i < 90; i++) { var ang = -Math.PI * (0.08 + rand() * 0.84); var sp = 600 + rand() * 1400; conf.push({ vx: Math.cos(ang) * sp * 0.9, vy: Math.sin(ang) * sp, w: 12 + rand() * 18, h: 7 + rand() * 12, rot: rand() * 6.28, vr: (rand() - 0.5) * 14, col: pal.conf[i % pal.conf.length], circ: rand() < 0.3 }); }

    // pre-randare umbra card (o singura data)
    var PAD = 90, shC = document.createElement('canvas');
    shC.width = CW + PAD * 2; shC.height = CH + PAD * 2;
    (function () {
      var x = shC.getContext('2d');
      x.shadowColor = 'rgba(10,8,20,0.38)'; x.shadowBlur = 64; x.shadowOffsetY = 34;
      x.fillStyle = '#ffffff'; rrect(x, PAD, PAD, CW, CH, 56); x.fill();
    })();

    var lay = null;   // layout text (calculat o data, dupa incarcarea fontului)

    function font(w, px) { return w + ' ' + px + 'px ' + FONT_STACK; }

    function wrap(c, text, f, maxW, maxLines) {
      c.font = f;
      var words = String(text).split(/\s+/), lines = [], cur = '';
      for (var k = 0; k < words.length; k++) {
        var test = cur ? cur + ' ' + words[k] : words[k];
        if (c.measureText(test).width <= maxW || !cur) cur = test; else { lines.push(cur); cur = words[k]; }
      }
      if (cur) lines.push(cur);
      return lines;
    }

    function layout(c) {
      var px = TALL ? 56 : 68, lines;
      function fit(tt) {
        for (var q = TALL ? 56 : 68; q >= 44; q -= 4) { var ls = wrap(c, tt, font(800, q), 900, 2); if (ls.length <= 2) { px = q; lines = ls; return true; } }
        return false;
      }
      // titlu prea lung: mai intai fara coada de detalii (" – Piele naturala + ..."), abia apoi cu "…"
      if (!fit(d.title)) {
        var shortT = String(d.title).split(/\s[–—-]\s/)[0];
        if (!(shortT && shortT !== d.title && fit(shortT))) {
          px = 46; lines = wrap(c, d.title, font(800, px), 900, 2).slice(0, 2);
          c.font = font(800, px);
          var l2 = lines[1] || ''; while (l2.length > 3 && c.measureText(l2 + '…').width > 900) l2 = l2.slice(0, -1);
          lines[1] = l2.replace(/\s+$/, '') + '…';
        }
      }
      var hook = ['Uite ce produs', 'am găsit!'], hpx = TALL ? 112 : 124;
      for (; hpx >= 80; hpx -= 4) { c.font = font(800, hpx); if (c.measureText(hook[0]).width <= 920) break; }
      var sizes = d.sizes.slice(), more = 0;
      if (sizes.length > 9) { more = sizes.length - 8; sizes = sizes.slice(0, 8); }
      lay = { titleLines: lines, titlePx: px, hook: hook, hookPx: hpx, sizes: sizes, more: more, vendor: (d.vendor || '').toUpperCase() };
    }

    function spaced(c, s, x, y, sp, align) {
      var w = 0, k, ws = [];
      for (k = 0; k < s.length; k++) { var cw = c.measureText(s[k]).width; ws.push(cw); w += cw + (k < s.length - 1 ? sp : 0); }
      var sx = align === 'center' ? x - w / 2 : align === 'right' ? x - w : x;
      for (k = 0; k < s.length; k++) { c.fillText(s[k], sx, y); sx += ws[k] + sp; }
      return w;
    }

    function shadowOn(c, blur, oy, col) { c.shadowColor = col || 'rgba(0,0,0,0.22)'; c.shadowBlur = blur * o.scale; c.shadowOffsetY = oy * o.scale; c.shadowOffsetX = 0; }
    function shadowOff(c) { c.shadowColor = 'rgba(0,0,0,0)'; c.shadowBlur = 0; c.shadowOffsetY = 0; }

    /* ---------- fundal */
    function drawBg(c, t) {
      var ang = -0.95 + t * 0.07, R = 1500, cx = W / 2, cy = H / 2;
      var g = c.createLinearGradient(cx - Math.cos(ang) * R, cy - Math.sin(ang) * R, cx + Math.cos(ang) * R, cy + Math.sin(ang) * R);
      g.addColorStop(0, pal.c1); g.addColorStop(1, pal.c2);
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      for (var b = 0; b < 5; b++) {
        var bx = W * (0.5 + 0.5 * Math.sin(t * 0.33 + b * 1.9)), by = H * (0.5 + 0.5 * Math.cos(t * 0.27 + b * 2.7)), br = 520 + 90 * b;
        var rg = c.createRadialGradient(bx, by, 0, bx, by, br);
        rg.addColorStop(0, pal.blob); rg.addColorStop(1, 'rgba(255,255,255,0)');
        c.fillStyle = rg; c.fillRect(bx - br, by - br, br * 2, br * 2);
      }
      var vg = c.createLinearGradient(0, 760, 0, H);
      vg.addColorStop(0, 'rgba(60,0,60,0)'); vg.addColorStop(1, pal.vig || 'rgba(70,0,70,0.26)');
      c.fillStyle = vg; c.fillRect(0, 760, W, H - 760);
      for (var k = 0; k < bokeh.length; k++) {
        var p = bokeh[k], y = ((p.y0 - t * p.v) % (H + 300) + (H + 300)) % (H + 300) - 150, x = p.x + Math.sin(t * p.f + p.ph) * 34;
        c.fillStyle = 'rgba(255,255,255,' + p.a + ')'; c.beginPath(); c.arc(x, y, p.r, 0, 6.2832); c.fill();
      }
    }

    /* ---------- logo */
    function drawLogo(c, t) {
      var p = lerp(0.88, 1, eOutBack(T(t, 0, 0.6))), a = 1;
      c.save(); c.globalAlpha = a; c.translate(540, 142); c.scale(p, p);
      shadowOn(c, 26, 12, 'rgba(10,8,20,0.28)');
      c.fillStyle = '#ffffff';
      if (logo) {
        var lh = 120, lw = lh * logo.naturalWidth / logo.naturalHeight, pw = lw + 56, ph = lh + 30;
        rrect(c, -pw / 2, -ph / 2, pw, ph, 36); c.fill(); shadowOff(c);
        c.drawImage(logo, -lw / 2, -lh / 2, lw, lh);
      } else {
        c.font = font(800, 60); var tw = c.measureText(STORE).width, pw2 = tw + 80;
        rrect(c, -pw2 / 2, -62, pw2, 124, 62); c.fill(); shadowOff(c);
        c.fillStyle = pal.c2; c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillText(STORE, 0, 4);
      }
      c.restore();
    }

    /* ---------- card foto */
    function drawCard(c, k, cx, cy, rot, sc, alpha, kb) {
      var s = shots[k]; if (!s || alpha <= 0.002) return;
      var im = s.img, iw = im.naturalWidth || im.width, ih = im.naturalHeight || im.height;
      c.save(); c.translate(cx, cy); c.rotate(rot); c.scale(sc, sc); c.globalAlpha = alpha;
      c.drawImage(shC, -CW / 2 - PAD, -CH / 2 - PAD);
      rrect(c, -CW / 2, -CH / 2, CW, CH, 56); c.save(); c.clip();
      // poza are forma cardului => acopera (cover); altfel o aratam ENTREGA (contain) peste un fundal din ea insasi, estompat
      var cover = !s.uniform && Math.abs(Math.log((iw / ih) / (CW / CH))) < 0.22;
      if (!cover && !s.uniform && s.backdrop) {
        var bw = s.backdrop.width, bh = s.backdrop.height, bs = Math.max(CW / bw, CH / bh);
        c.drawImage(s.backdrop, -bw * bs / 2, -bh * bs / 2, bw * bs, bh * bs);
        c.fillStyle = 'rgba(255,255,255,0.28)'; c.fillRect(-CW / 2 - 4, -CH / 2 - 4, CW + 8, CH + 8);
      } else { c.fillStyle = s.bg; c.fillRect(-CW / 2 - 4, -CH / 2 - 4, CW + 8, CH + 8); }
      var base = cover ? Math.max(CW / iw, CH / ih) : Math.min(CW / iw, CH / ih);
      var zoom = 1 + (cover ? 0.12 : 0.025) * kb, dir = (k % 2) ? 1 : -1;
      var fx = [0, 0.4, -0.35, 0.2][k % 4], mv = cover ? 1 : 0.3;
      var dw = iw * base * zoom, dh = ih * base * zoom;
      var px = (dir * 46 * (kb - 0.5) + fx * 60) * mv, py = -26 * (kb - 0.5) * mv;
      c.drawImage(im, -dw / 2 + px, -dh / 2 + py, dw, dh);
      c.restore();
      // puncte progres
      var n = N, gap = 26, tw = (n - 1) * gap;
      for (var i = 0; i < n; i++) {
        var on = i === k;
        c.fillStyle = on ? pal.c2 : 'rgba(30,30,40,0.22)';
        c.beginPath(); c.arc(-tw / 2 + i * gap, CH / 2 - 34, on ? 8 : 6, 0, 6.2832); c.fill();
      }
      c.restore();
    }

    function drawCards(c, t, outP) {
      // cardul curent, cel anterior iese
      var k = Math.min(N - 1, Math.floor(t / SHOT)), u = t - k * SHOT;
      var cy = lerp(CCY, OUT_CY, outP), sc0 = lerp(1, OUT_SC, outP);
      if (k === 0) {
        var p0 = eOutBack(T(u, 0, 0.8)), a0 = 1;
        drawCard(c, 0, CCX, cy + (1 - p0) * 46, (1 - p0) * -0.025, sc0 * lerp(0.93, 1, p0), a0, clamp01(u / SHOT));
      } else {
        var p = eOutCubic(T(u, 0, 0.55));
        if (p < 1) {
          var pk = k - 1;
          drawCard(c, pk, CCX - p * 1050, cy + p * 30, -p * 0.09, sc0 * (1 - 0.07 * p), 1 - 0.45 * p, clamp01((SHOT + u) / SHOT));
        }
        drawCard(c, k, CCX + (1 - p) * 1050, cy - (1 - p) * 30, (1 - p) * 0.1, sc0 * (0.93 + 0.07 * p), 1, clamp01(u / SHOT));
      }
    }

    /* ---------- badge reducere / nou */
    function drawBadge(c, t, outP) {
      if (outP >= 1) return;
      var txt = d.pct ? '-' + d.pct + '%' : (d.isNew ? 'NOU' : '');
      if (!txt) return;
      var p = eOutBack(T(t, 1.15, 1.75)); if (p <= 0) return;
      var cx = CCX + CW / 2 - 52, cy = CCY - CH / 2 + 22;
      c.save(); c.globalAlpha = 1 - outP;
      c.translate(cx, cy); c.rotate(-0.2 + Math.sin(t * 2.4) * 0.05); c.scale(p * (1 + 0.04 * Math.sin(t * 5)), p * (1 + 0.04 * Math.sin(t * 5)));
      shadowOn(c, 22, 10, 'rgba(10,8,20,0.35)');
      c.fillStyle = pal.badge;
      // stea cu 14 colturi
      var rO = 92, rI = 80, pts = 14;
      c.beginPath();
      for (var i = 0; i < pts * 2; i++) { var rr = i % 2 ? rI : rO, a = Math.PI * i / pts; c.lineTo(Math.cos(a) * rr, Math.sin(a) * rr); }
      c.closePath(); c.fill(); shadowOff(c);
      c.fillStyle = pal.badgeInk; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.font = font(800, txt.length > 3 ? 54 : 60); c.fillText(txt, 0, 4);
      c.restore();
    }

    /* ---------- hook (primele ~1.8 s) */
    function drawHook(c, t) {
      var a = 1 - eInOutCubic(T(t, 1.28, 1.7)); if (a <= 0.003) return;
      var out = eInOutCubic(T(t, 1.28, 1.7));
      c.save(); c.globalAlpha = a; c.textAlign = 'center'; c.textBaseline = 'alphabetic';
      var y1 = CB + (TALL ? 100 : 190), y2 = y1 + lay.hookPx * 0.98;
      var l1 = eOutBack(T(t, 0.25, 0.8)), l2 = eOutBack(T(t, 0.42, 0.97));
      shadowOn(c, 24, 8, 'rgba(10,8,25,0.28)');
      c.fillStyle = '#ffffff'; c.font = font(800, lay.hookPx);
      c.save(); c.globalAlpha = a * clamp01(l1 * 1.4); c.fillText(lay.hook[0], 540, y1 + (1 - l1) * 70 - out * 40); c.restore();
      c.save(); c.globalAlpha = a * clamp01(l2 * 1.4); c.fillStyle = pal.accent; c.fillText(lay.hook[1], 540, y2 + (1 - l2) * 70 - out * 40); c.restore();
      shadowOff(c);
      // sublinie
      c.save(); c.globalAlpha = a; c.strokeStyle = 'rgba(255,255,255,0.9)'; c.lineWidth = 10; c.lineCap = 'round';
      var lw = 330 * eOutCubic(T(t, 0.8, 1.3)); c.beginPath(); c.moveTo(540 - lw / 2, y2 + 46 - out * 40); c.lineTo(540 + lw / 2, y2 + 46 - out * 40); c.stroke();
      c.restore();
      c.restore();
    }

    /* ---------- info produs (de la ~1.65 s pana la outro) */
    function drawInfo(c, t, outP) {
      var a0 = 1 - clamp01(outP * 2.2); if (a0 <= 0.003) return;
      var base = 1.72;
      function st(delay, dur) { var p = T(t, base + delay, base + delay + (dur || 0.55)); return { p: eOutCubic(p), a: clamp01(p * 2) * a0 }; }
      var vendorY = CB + (TALL ? 56 : 68), titleY = vendorY + (TALL ? 70 : 94), lineGap = lay.titlePx + (TALL ? 10 : 14);
      var lastBase = titleY + (lay.titleLines.length - 1) * lineGap;
      var pyc = lastBase + (TALL ? 78 : 114);    // centrul pastilei de pret
      c.save(); c.textBaseline = 'alphabetic'; c.textAlign = 'left';
      var s;
      // vendor
      s = st(0);
      if (lay.vendor) {
        c.save(); c.globalAlpha = s.a; c.fillStyle = pal.accent; c.font = font(800, TALL ? 38 : 42);
        shadowOn(c, 12, 3, 'rgba(10,8,25,0.3)'); spaced(c, lay.vendor, 90, vendorY + (1 - s.p) * 40, 8, 'left'); shadowOff(c); c.restore();
      }
      // titlu
      s = st(0.08);
      c.save(); c.globalAlpha = s.a; c.fillStyle = '#ffffff'; c.font = font(800, lay.titlePx); shadowOn(c, 18, 6, 'rgba(10,8,25,0.28)');
      for (var i = 0; i < lay.titleLines.length; i++) c.fillText(lay.titleLines[i], 90, titleY + i * lineGap + (1 - s.p) * 50);
      shadowOff(c); c.restore();
      // pret
      s = st(0.2, 0.7);
      var pr = eOutBack(T(t, base + 0.2, base + 0.9));
      var nPx = TALL ? 76 : 84, lPx = TALL ? 42 : 46, ph = TALL ? 100 : 116;
      c.save(); c.globalAlpha = s.a;
      c.font = font(800, nPx); var numTxt = fmtPrice(d.price), nw = c.measureText(numTxt).width;
      c.font = font(800, lPx); var lei = ' lei', lw2 = c.measureText(lei).width;
      var pw = nw + lw2 + 80, px0 = 90;
      c.translate(px0, pyc); c.scale(0.85 + 0.15 * pr, 0.85 + 0.15 * pr);
      shadowOn(c, 22, 10, 'rgba(10,8,25,0.28)');
      c.fillStyle = pal.pill; rrect(c, 0, -ph / 2, pw, ph, ph / 2); c.fill(); shadowOff(c);
      c.fillStyle = pal.ink; c.textBaseline = 'alphabetic';
      c.font = font(800, nPx); c.fillText(numTxt, 40, nPx * 0.36);
      c.font = font(800, lPx); c.fillText(lei, 40 + nw, nPx * 0.36);
      c.restore();
      var rightX = px0 + pw + 30;
      if (d.cmp) {
        c.save(); c.globalAlpha = s.a;
        c.font = font(700, TALL ? 42 : 48); c.fillStyle = 'rgba(255,255,255,0.88)';
        var ot = fmtPrice(d.cmp) + ' lei', ow = c.measureText(ot).width;
        shadowOn(c, 12, 3, 'rgba(10,8,25,0.3)'); c.fillText(ot, rightX, pyc + 12); shadowOff(c);
        c.strokeStyle = '#ffffff'; c.lineWidth = 6; c.beginPath(); c.moveTo(rightX - 6, pyc - 2); c.lineTo(rightX + ow + 6, pyc - 2); c.stroke();
        c.restore();
        rightX += ow + 30;
      }
      // marimi (doar daca produsul are marimi reale)
      if (lay.sizes.length && !TALL) {
        s = st(0.38);
        c.save(); c.globalAlpha = s.a; c.fillStyle = '#ffffff'; c.font = font(700, 38); shadowOn(c, 12, 3, 'rgba(10,8,25,0.32)');
        c.fillText('Mărimi disponibile', 90, pyc + 114 + (1 - s.p) * 30); shadowOff(c); c.restore();
        var cr = 40, gap = 16, x0 = 90 + cr;
        for (var k = 0; k < lay.sizes.length + (lay.more ? 1 : 0); k++) {
          var cs = eOutBack(T(t, base + 0.5 + k * 0.05, base + 0.95 + k * 0.05));
          if (cs <= 0) continue;
          var cxk = x0 + k * (cr * 2 + gap), cyk = pyc + 190;
          c.save(); c.globalAlpha = a0; c.translate(cxk, cyk); c.scale(cs, cs);
          shadowOn(c, 12, 4, 'rgba(10,8,25,0.25)'); c.fillStyle = k < lay.sizes.length ? 'rgba(255,255,255,0.97)' : 'rgba(255,255,255,0.3)';
          c.beginPath(); c.arc(0, 0, cr, 0, 6.2832); c.fill(); shadowOff(c);
          c.fillStyle = k < lay.sizes.length ? pal.ink : '#ffffff'; c.textAlign = 'center'; c.textBaseline = 'middle';
          var lab = k < lay.sizes.length ? lay.sizes[k] : '+' + lay.more;
          c.font = font(800, lab.length > 3 ? 28 : 40); c.fillText(lab, 0, 2);
          c.restore();
        }
      } else if (lay.sizes.length && TALL && !d.cmp) {
        // card inalt: marimile stau pe acelasi rand cu pretul, in dreapta
        var cr2 = 30, gap2 = 10, fit = Math.max(0, Math.floor((1080 - 70 - rightX) / (cr2 * 2 + gap2)));
        var show = lay.sizes.slice(0, Math.min(fit, 6)), extra = lay.sizes.length - show.length;
        if (show.length) {
          for (var k2 = 0; k2 < show.length + (extra > 0 ? 1 : 0); k2++) {
            var cs2 = eOutBack(T(t, base + 0.5 + k2 * 0.05, base + 0.95 + k2 * 0.05));
            if (cs2 <= 0) continue;
            c.save(); c.globalAlpha = a0; c.translate(rightX + cr2 + k2 * (cr2 * 2 + gap2), pyc); c.scale(cs2, cs2);
            shadowOn(c, 10, 3, 'rgba(10,8,25,0.25)'); c.fillStyle = k2 < show.length ? 'rgba(255,255,255,0.97)' : 'rgba(255,255,255,0.3)';
            c.beginPath(); c.arc(0, 0, cr2, 0, 6.2832); c.fill(); shadowOff(c);
            c.fillStyle = k2 < show.length ? pal.ink : '#ffffff'; c.textAlign = 'center'; c.textBaseline = 'middle';
            var lab2 = k2 < show.length ? show[k2] : '+' + extra;
            c.font = font(800, lab2.length > 3 ? 22 : 30); c.fillText(lab2, 0, 2);
            c.restore();
          }
        }
      }
      // incredere (doar cand mai e loc in zona sigura)
      var trustY = pyc + (lay.sizes.length ? 282 : 150);
      if (!TALL && trustY <= 1600) {
        s = st(0.7, 0.6);
        c.save(); c.globalAlpha = s.a; c.fillStyle = '#ffffff'; c.font = font(700, 35); c.textAlign = 'left'; shadowOn(c, 12, 3, 'rgba(10,8,25,0.32)');
        c.fillText('Plată la livrare  •  Produse originale', 90, trustY + (1 - s.p) * 20); shadowOff(c);
        c.restore();
      }
      c.restore();
    }

    /* ---------- outro (CTA) */
    function drawOutro(c, t) {
      var u = t - tOut; if (u < 0.28) return;
      c.save(); c.textBaseline = 'alphabetic'; c.textAlign = 'center';
      var s1 = eOutCubic(T(u, 0.3, 0.85)), s2 = eOutBack(T(u, 0.5, 1.15)), s3 = eOutCubic(T(u, 0.9, 1.5)), s4 = eOutCubic(T(u, 1.2, 1.7));
      // "Comanda acum"
      c.save(); c.globalAlpha = clamp01(s1 * 1.5); shadowOn(c, 22, 8, 'rgba(10,8,25,0.3)');
      c.fillStyle = '#ffffff'; c.font = font(800, 104); c.fillText('Comandă acum', 540, 905 + (1 - s1) * 60);
      shadowOff(c); c.restore();
      // CTA
      var cw = 800, chh = 148, cy = 1052;
      var pulse = (u - 1.0) > 0 ? 0.5 + 0.5 * Math.sin((u - 1.0) * 5.2) : 0;
      // inele
      for (var r = 0; r < 2; r++) {
        var ph = (((u - 0.9 - r * 0.5) % 1.0) + 1.0) % 1.0, ra = (u > 0.9) ? (1 - ph) * 0.45 : 0;
        if (ra > 0.01) { c.save(); c.globalAlpha = ra * s2; c.strokeStyle = '#ffffff'; c.lineWidth = 8; rrect(c, 540 - cw / 2 - ph * 70, cy - chh / 2 - ph * 70, cw + ph * 140, chh + ph * 140, (chh + ph * 140) / 2); c.stroke(); c.restore(); }
      }
      c.save(); c.translate(540, cy); var sc = s2 * (1 + 0.025 * pulse); c.scale(sc, sc); c.globalAlpha = clamp01(s2 * 1.4);
      shadowOn(c, 34, 16, 'rgba(10,8,25,0.34)');
      c.fillStyle = pal.cta; rrect(c, -cw / 2, -chh / 2, cw, chh, chh / 2); c.fill(); shadowOff(c);
      c.fillStyle = pal.ctaInk; c.font = font(800, 84); c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillText(STORE, -34, 6);
      // sageata
      c.fillStyle = pal.ctaArrow; c.beginPath(); c.arc(cw / 2 - 76, 0, 44, 0, 6.2832); c.fill();
      c.strokeStyle = (pal.ctaArrow === '#ffffff') ? pal.ctaInk : '#ffffff'; c.lineWidth = 9; c.lineCap = 'round'; c.lineJoin = 'round';
      c.beginPath(); c.moveTo(cw / 2 - 92, 0); c.lineTo(cw / 2 - 58, 0); c.moveTo(cw / 2 - 74, -17); c.lineTo(cw / 2 - 57, 0); c.lineTo(cw / 2 - 74, 17); c.stroke();
      c.restore();
      // pret
      c.save(); c.globalAlpha = s3; c.translate(540, 1232 + (1 - s3) * 40);
      c.textBaseline = 'alphabetic';
      var numTxt = fmtPrice(d.price);
      c.font = font(800, 92); var nw = c.measureText(numTxt).width; c.font = font(800, 50); var lw = c.measureText(' lei').width;
      var oldTxt = d.cmp ? fmtPrice(d.cmp) + ' lei' : ''; c.font = font(700, 46); var ow = oldTxt ? c.measureText(oldTxt).width + 28 : 0;
      var tot = nw + lw + ow, x0 = -tot / 2;
      shadowOn(c, 20, 6, 'rgba(10,8,25,0.28)');
      c.textAlign = 'left'; c.fillStyle = '#ffffff';
      if (oldTxt) { c.font = font(700, 46); c.globalAlpha = s3 * 0.85; c.fillText(oldTxt, x0, 0); c.strokeStyle = '#fff'; c.lineWidth = 4; c.beginPath(); c.moveTo(x0 - 4, -12); c.lineTo(x0 + ow - 24, -12); c.stroke(); c.globalAlpha = s3; x0 += ow; }
      c.font = font(800, 92); c.fillStyle = pal.accent; c.fillText(numTxt, x0, 0);
      c.font = font(800, 50); c.fillText(' lei', x0 + nw, 0);
      shadowOff(c); c.restore();
      // avantaje
      var items = ['Plată la livrare sau cu cardul', 'Produse 100% originale'];
      for (var i = 0; i < items.length; i++) {
        var p = eOutBack(T(u, 1.2 + i * 0.16, 1.7 + i * 0.16)); if (p <= 0) continue;
        c.save(); c.globalAlpha = clamp01(p * 1.5); c.translate(0, (1 - p) * 30);
        var iy = 1382 + i * 84; c.font = font(700, 42); c.textAlign = 'left';
        var tw = c.measureText(items[i]).width, bx = 540 - (tw + 76) / 2;
        shadowOn(c, 14, 4, 'rgba(10,8,25,0.25)');
        c.fillStyle = '#ffffff'; c.beginPath(); c.arc(bx + 26, iy - 14, 26, 0, 6.2832); c.fill();
        shadowOff(c);
        c.strokeStyle = pal.c2; c.lineWidth = 7; c.lineCap = 'round'; c.lineJoin = 'round';
        c.beginPath(); c.moveTo(bx + 14, iy - 13); c.lineTo(bx + 23, iy - 3); c.lineTo(bx + 40, iy - 25); c.stroke();
        c.fillStyle = '#ffffff'; shadowOn(c, 14, 4, 'rgba(10,8,25,0.28)'); c.fillText(items[i], bx + 76, iy); shadowOff(c);
        c.restore();
      }
      // magazin fizic (vocea il spune in outro)
      var sp = eOutCubic(T(u, 2.1, 2.7));
      if (sp > 0) {
        c.save(); c.globalAlpha = sp; c.textAlign = 'center'; c.textBaseline = 'alphabetic'; c.fillStyle = '#ffffff'; c.font = font(800, 42);
        shadowOn(c, 12, 3, 'rgba(10,8,25,0.32)'); c.fillText('Total Shoes Land · Bacău, str. Mioriței nr. 16', 540, 1584 + (1 - sp) * 20); shadowOff(c);
        c.restore();
      }
      // confetti
      var tc = u - 0.42;
      if (tc > 0 && tc < 2.6) {
        for (var k = 0; k < conf.length; k++) {
          var q = conf[k], x = 540 + q.vx * tc, y = 1052 + q.vy * tc + 0.5 * 2100 * tc * tc, al = 1 - T(tc, 1.6, 2.6);
          if (y > H + 40 || al <= 0) continue;
          c.save(); c.globalAlpha = al; c.translate(x, y); c.rotate(q.rot + q.vr * tc); c.fillStyle = q.col;
          if (q.circ) { c.beginPath(); c.arc(0, 0, q.h * 0.7, 0, 6.2832); c.fill(); } else c.fillRect(-q.w / 2, -q.h / 2, q.w, q.h);
          c.restore();
        }
      }
      c.restore();
    }

    /* ---------- filigran jos (zona acoperita de interfata Story; ramane brandul) */
    function drawFooter(c, t, outP) {
      var a = clamp01(T(t, 0.7, 1.3)) * (1 - clamp01(outP * 3)); if (a <= 0.003) return;
      c.save(); c.globalAlpha = a * 0.92; c.textAlign = 'center'; c.textBaseline = 'alphabetic'; c.fillStyle = '#ffffff';
      c.font = font(800, 46); shadowOn(c, 14, 4, 'rgba(10,8,25,0.3)');
      c.fillText(STORE, 540, 1816); shadowOff(c);
      c.globalAlpha = a * 0.55; c.fillRect(540 - 36, 1840, 72, 5);
      c.restore();
    }

    /* ---------- cadrul complet */
    this.setScale = function (v) { o.scale = v; };
    this.voice = o.voice || null;
    this.D = D; this.tOut = tOut; this.tPoster = Math.min(SHOT + 1.5, tOut - 0.1); this.N = N;
    this.render = function (c, t) {
      if (!lay) layout(c);
      c.setTransform(o.scale, 0, 0, o.scale, 0, 0);
      c.globalAlpha = 1; c.textAlign = 'left'; c.textBaseline = 'alphabetic'; shadowOff(c);
      drawBg(c, t);
      var outP = eInOutCubic(T(t, tOut, tOut + 0.75));
      c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
      drawLogo(c, t);
      drawFooter(c, t, outP);
      drawCards(c, t, outP);
      drawBadge(c, t, outP);
      drawHook(c, t);
      drawInfo(c, t, outP);
      drawOutro(c, t);
    };
  }

  /* ------------------------------------------------------------------ muzica (sintetizata, fara fisiere audio) */
  async function synthAudio(D, tOut, voice) {
    var OAC = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    if (!OAC) return null;
    var SR = 48000, ctx = new OAC(2, Math.ceil(D * SR), SR);
    var comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -16; comp.knee.value = 12; comp.ratio.value = 4; comp.attack.value = 0.004; comp.release.value = 0.18;
    var master = ctx.createGain(); master.gain.setValueAtTime(0.0001, 0); master.gain.linearRampToValueAtTime(0.9, 0.06);
    master.gain.setValueAtTime(0.9, Math.max(0.1, D - 1.1)); master.gain.linearRampToValueAtTime(0.0001, D - 0.02);
    master.connect(comp); comp.connect(ctx.destination);
    var music = ctx.createGain(); music.connect(master);   // muzica trece printr-un bus separat (se atenueaza cat vorbeste vocea)
    var beat = SHOT / 4;
    function mf(m) { return 440 * Math.pow(2, (m - 69) / 12); }
    var chords = [[60, 64, 67], [59, 62, 67], [57, 60, 64], [57, 60, 65]];  // C, G/B, Am, F(add) - voicing apropiat
    var roots = [36, 43, 45, 41];
    var nBars = Math.ceil(D / SHOT);
    var noiseBuf = ctx.createBuffer(1, SR * 2, SR), nd = noiseBuf.getChannelData(0), rr = rng(99);
    for (var i = 0; i < nd.length; i++) nd[i] = rr() * 2 - 1;

    function env(g, t0, a, d, peak, end) { g.gain.setValueAtTime(0.0001, t0); g.gain.linearRampToValueAtTime(peak, t0 + a); g.gain.exponentialRampToValueAtTime(0.0001, t0 + a + d); }
    function sust(type, freq, t0, dur, peak, att, rel, cutoff, pan) {   // nota sustinuta (pad)
      var o = ctx.createOscillator(); o.type = type; o.frequency.value = freq;
      var g = ctx.createGain(), f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = cutoff || 1400; f.Q.value = 0.6;
      g.gain.setValueAtTime(0.0001, t0); g.gain.linearRampToValueAtTime(peak, t0 + att);
      g.gain.setValueAtTime(peak, Math.max(t0 + att, t0 + dur - rel)); g.gain.linearRampToValueAtTime(0.0001, t0 + dur);
      o.connect(f); f.connect(g);
      var last = g;
      if (pan && ctx.createStereoPanner) { var p = ctx.createStereoPanner(); p.pan.value = pan; g.connect(p); last = p; }
      last.connect(music); o.start(t0); o.stop(t0 + dur + 0.05);
    }
    function osc(type, freq, t0, dur, peak, a, cutoff, pan) {
      var o = ctx.createOscillator(); o.type = type; o.frequency.value = freq;
      var g = ctx.createGain(), f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = cutoff || 4000; f.Q.value = 0.7;
      env(g, t0, a, dur, peak); o.connect(f); f.connect(g);
      var last = g;
      if (pan && ctx.createStereoPanner) { var p = ctx.createStereoPanner(); p.pan.value = pan; g.connect(p); last = p; }
      last.connect(music); o.start(t0); o.stop(t0 + a + dur + 0.05);
    }
    function kick(t0, gain) {
      var o = ctx.createOscillator(), g = ctx.createGain(); o.type = 'sine';
      o.frequency.setValueAtTime(150, t0); o.frequency.exponentialRampToValueAtTime(46, t0 + 0.11);
      g.gain.setValueAtTime(gain, t0); g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.34);
      o.connect(g); g.connect(music); o.start(t0); o.stop(t0 + 0.36);
    }
    function noise(t0, dur, type, freq, peak, q, a) {
      var s = ctx.createBufferSource(); s.buffer = noiseBuf;
      var f = ctx.createBiquadFilter(); f.type = type; f.frequency.value = freq; f.Q.value = q || 0.8;
      var g = ctx.createGain(); env(g, t0, a || 0.002, dur, peak);
      s.connect(f); f.connect(g); g.connect(music); s.start(t0, 0, Math.min(dur + 0.1, 1.9)); s.stop(t0 + dur + 0.12);
    }
    function riser(t0, dur, peak) {
      var s = ctx.createBufferSource(); s.buffer = noiseBuf; s.loop = true;
      var f = ctx.createBiquadFilter(); f.type = 'bandpass'; f.Q.value = 1.4; f.frequency.setValueAtTime(400, t0); f.frequency.exponentialRampToValueAtTime(9000, t0 + dur);
      var g = ctx.createGain(); g.gain.setValueAtTime(0.0001, t0); g.gain.exponentialRampToValueAtTime(peak, t0 + dur); g.gain.linearRampToValueAtTime(0.0001, t0 + dur + 0.05);
      s.connect(f); f.connect(g); g.connect(music); s.start(t0); s.stop(t0 + dur + 0.1);
    }
    function whoosh(tc) { riser(Math.max(0, tc - 0.32), 0.36, 0.2); }

    for (var b = 0; b < nBars; b++) {
      var tb = b * SHOT, outro = tb >= tOut - 1e-6, ci = outro ? 0 : (b % 4), ch = chords[ci];
      if (tb >= D) break;
      // pad
      for (var n = 0; n < ch.length; n++) {
        sust('sawtooth', mf(ch[n]) * 0.997, tb, SHOT + 0.12, 0.05, 0.1, 0.35, 1500, -0.3);
        sust('sawtooth', mf(ch[n]) * 1.003, tb, SHOT + 0.12, 0.05, 0.1, 0.35, 1500, 0.3);
      }
      // bass pe optimi
      for (var e = 0; e < 8; e++) {
        var tn = tb + e * beat / 2, rn = roots[ci] + (e % 4 === 3 ? 12 : 0);
        if (b === 0 && e < 2) continue;
        osc('triangle', mf(rn), tn, beat * 0.42, 0.2, 0.004, 700);
      }
      // arpegiu
      var arp = [0, 1, 2, 1, 0, 2, 1, 2];
      for (e = 0; e < 8; e++) {
        var tn2 = tb + e * beat / 2 + (b === 0 ? 0 : 0);
        osc('triangle', mf(ch[arp[e]] + 12), tn2, 0.2, 0.075, 0.003, 4200, e % 2 ? 0.35 : -0.35);
      }
      // tobe
      for (var k2 = 0; k2 < 4; k2++) {
        var tk = tb + k2 * beat;
        kick(tk, b === 0 ? 0.5 : 0.8);
        if (b >= 1 && (k2 === 1 || k2 === 3)) noise(tk, 0.12, 'bandpass', 1700, 0.3, 0.9);
        if (b >= 1) noise(tk + beat / 2, 0.045, 'highpass', 7500, 0.12, 0.7);
      }
      // whoosh la schimbarea pozei
      if (b >= 1 && !outro && b < N_SHOTS()) whoosh(tb);
    }
    function N_SHOTS() { return Math.round(tOut / SHOT); }
    // build-up + impact la intrarea in outro
    riser(Math.max(0, tOut - 1.1), 1.1, 0.34);
    kick(tOut, 1.0);
    noise(tOut, 1.5, 'highpass', 5500, 0.34, 0.6, 0.004);
    osc('sine', mf(36), tOut, 1.2, 0.35, 0.004, 400);
    for (var q = 0; q < 3; q++) { osc('sawtooth', mf(chords[0][q] + 12), tOut, 1.6, 0.06, 0.01, 2600, q - 1 ? 0.2 : -0.2); }
    // clopote la CTA (ping-uri ascendente)
    [72, 76, 79, 84].forEach(function (m, i) { osc('sine', mf(m), tOut + 0.55 + i * 0.12, 0.7, 0.07, 0.004, 6000, i % 2 ? 0.3 : -0.3); });

    // ---- voce: sosire pe un bus propriu + atenuarea muzicii in timpul vorbirii ("ducking")
    if (voice && voice.length) {
      var HI = 0.8, LO = 0.3;
      var vs = voice.slice().sort(function (a, b) { return a.start - b.start; });
      var wins = [];
      vs.forEach(function (x) {
        var a = Math.max(0, x.start - 0.15), b = x.start + x.dur / (x.rate || 1) + 0.15, last = wins[wins.length - 1];
        if (last && a - last[1] < 0.7) last[1] = Math.max(last[1], b); else wins.push([a, b]);
      });
      music.gain.setValueAtTime(HI, 0);
      wins.forEach(function (w) {
        music.gain.setValueAtTime(HI, w[0]);
        music.gain.linearRampToValueAtTime(LO, w[0] + 0.12);
        music.gain.setValueAtTime(LO, Math.max(w[0] + 0.12, w[1]));
        music.gain.linearRampToValueAtTime(HI, w[1] + 0.4);
      });
      var vbus = ctx.createGain(); vbus.gain.value = 1.35; vbus.connect(master);
      vs.forEach(function (x) {
        var src = ctx.createBufferSource(); src.buffer = x.buf; src.playbackRate.value = x.rate || 1;
        var hp = ctx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 85;
        var g = ctx.createGain(); g.gain.value = x.gain || 1;
        src.connect(hp); hp.connect(g); g.connect(vbus);
        src.start(x.start, x.off || 0, x.dur);
      });
    }

    var buf = await ctx.startRendering();
    // normalizare: varf la ~ -2 dBFS
    var pk = 0;
    for (var ch2 = 0; ch2 < buf.numberOfChannels; ch2++) { var data = buf.getChannelData(ch2); for (var j = 0; j < data.length; j++) { var v = Math.abs(data[j]); if (v > pk) pk = v; } }
    if (pk > 0.0001) { var gain = 0.8 / pk; for (ch2 = 0; ch2 < buf.numberOfChannels; ch2++) { var dd = buf.getChannelData(ch2); for (j = 0; j < dd.length; j++) dd[j] *= gain; } }
    return buf;
  }

  /* ------------------------------------------------------------------ voce (server: retur.totalpantofi.ro/api/story-voice) */
  var VOICE_API = 'https://retur.totalpantofi.ro/api/story-voice';
  function voiceApi() {
    try { var m = location.search.match(/[?&]tps_voice_api=([^&]+)/); if (DEBUG && m) return decodeURIComponent(m[1]); } catch (e) {}
    return VOICE_API;
  }
  async function fetchT(url, ms, opts) {
    var c = new AbortController(), t = setTimeout(function () { c.abort(); }, ms);
    try { return await fetch(url, Object.assign({ signal: c.signal, mode: 'cors', credentials: 'omit' }, opts || {})); }
    finally { clearTimeout(t); }
  }
  // taie linistea de la capetele clipului (TTS adauga ~0.2 s inainte si ~0.7 s dupa) si calculeaza amplificarea de normalizare
  function trimInfo(buf) {
    var d = buf.getChannelData(0), n = d.length, thr = 0.012, a = 0, b = n - 1, pk = 0, i;
    for (i = 0; i < n; i++) { var v = Math.abs(d[i]); if (v > pk) pk = v; }
    while (a < n && Math.abs(d[a]) < thr) a++;
    while (b > a && Math.abs(d[b]) < thr) b--;
    var sr = buf.sampleRate, pad = Math.round(0.05 * sr), s0 = Math.max(0, a - pad), s1 = Math.min(n, b + pad);
    return { buf: buf, off: s0 / sr, dur: Math.max(0.2, (s1 - s0) / sr), gain: pk > 0.001 ? Math.min(3, 0.9 / pk) : 1 };
  }
  // intoarce { hook, main, outro } = { buf, off, dur, gain }
  async function loadVoice(handle, v) {
    var r = await fetchT(voiceApi() + '?handle=' + encodeURIComponent(handle) + '&v=' + (v === 'm' ? 'm' : 'f'), 45000);
    if (!r.ok) throw new Error('voice-' + r.status);
    var j = await r.json();
    if (!j || !j.ok || !j.segments || j.segments.length < 3) throw new Error('voice-bad');
    var Dec = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    if (!Dec) throw new Error('voice-nodecoder');
    var dctx = new Dec(1, 1, 48000), out = {};
    await Promise.all(j.segments.map(async function (sg) {
      var ar = await fetchT(sg.url, 25000);
      if (!ar.ok) throw new Error('voice-audio-' + ar.status);
      var buf = await dctx.decodeAudioData(await ar.arrayBuffer());
      out[sg.id] = trimInfo(buf);
    }));
    if (!out.hook || !out.main || !out.outro) throw new Error('voice-incomplete');
    return out;
  }

  /* ------------------------------------------------------------------ codare */
  var _muxP = null;
  function loadMux() {
    if (window.Mp4Muxer) return Promise.resolve(window.Mp4Muxer);
    if (_muxP) return _muxP;
    _muxP = new Promise(function (resolve, reject) {
      var s = document.createElement('script'); s.src = assetUrl('tp-story-mux.js'); s.async = true;
      s.onload = function () { window.Mp4Muxer ? resolve(window.Mp4Muxer) : reject(new Error('mux-missing')); };
      s.onerror = function () { _muxP = null; reject(new Error('mux-load')); };
      document.head.appendChild(s);
    });
    return _muxP;
  }

  async function pickVideoConfig(bitrate) {
    if (typeof VideoEncoder === 'undefined' || typeof VideoFrame === 'undefined') return null;
    var codecs = ['avc1.640028', 'avc1.4d0028', 'avc1.42E028', 'avc1.64001f', 'avc1.4d001f', 'avc1.42E01f'];
    for (var i = 0; i < codecs.length; i++) {
      var cfg = { codec: codecs[i], width: PW, height: PH, bitrate: bitrate, framerate: FPS };
      try { var s = await VideoEncoder.isConfigSupported(cfg); if (s && s.supported) { cfg.avc = { format: 'avc' }; return cfg; } } catch (e) {}
    }
    return null;
  }
  async function pickAudioConfig() {
    if (typeof AudioEncoder === 'undefined' || typeof AudioData === 'undefined') return null;
    var cfg = { codec: 'mp4a.40.2', sampleRate: 48000, numberOfChannels: 2, bitrate: 128000 };
    try { var s = await AudioEncoder.isConfigSupported(cfg); if (s && s.supported) return cfg; } catch (e) {}
    return null;
  }

  function waitDequeue(enc) {
    return new Promise(function (r) {
      var done = false; function fin() { if (!done) { done = true; r(); } }
      try { enc.addEventListener('dequeue', fin, { once: true }); } catch (e) {}
      setTimeout(fin, 40);
    });
  }

  async function encodeAudioChunks(audioBuf, acfg) {
    var out = [], failure = null;
    var aenc = new AudioEncoder({ output: function (chunk, meta) { out.push({ chunk: chunk, meta: meta }); }, error: function (e) { failure = e; } });
    aenc.configure(acfg);
    try {
      var L = audioBuf.getChannelData(0), R = audioBuf.numberOfChannels > 1 ? audioBuf.getChannelData(1) : L, step = 4800;
      for (var off = 0; off < L.length; off += step) {
        var n = Math.min(step, L.length - off), pcm = new Float32Array(n * 2);
        pcm.set(L.subarray(off, off + n), 0); pcm.set(R.subarray(off, off + n), n);
        var ad = new AudioData({ format: 'f32-planar', sampleRate: 48000, numberOfFrames: n, numberOfChannels: 2, timestamp: Math.round(off / 48000 * 1e6), data: pcm });
        aenc.encode(ad); ad.close();
        if (failure) throw failure;
        if ((off / step) % 8 === 0) await tick();
      }
      await aenc.flush();
      if (failure) throw failure;
    } finally { try { aenc.close(); } catch (e) {} }
    return out;
  }

  // 1) WebCodecs + mp4-muxer
  async function encodeWebCodecs(scene, canvas, ctx, cancel, progress) {
    var br = SCALE < 1 ? 3500000 : 5500000;
    var vcfg = await pickVideoConfig(br);
    if (!vcfg) throw new Error('no-avc');
    var Mux = await loadMux();
    progress(0.04, 'Pregătim muzica…');
    var audioBuf = null, acfg = null;
    try { acfg = await pickAudioConfig(); if (acfg) audioBuf = await synthAudio(scene.D, scene.tOut, scene.voice); } catch (e) { log('audio', e); acfg = null; audioBuf = null; }
    if (cancel.v) throw new Error('cancel');
    // audio codat INAINTE de muxer: daca esueaza, facem video fara sunet (nu pierdem tot lantul rapid)
    var audioChunks = null;
    if (acfg && audioBuf) {
      try { audioChunks = await encodeAudioChunks(audioBuf, acfg); } catch (ae) { log('audio-encode esuat', ae); audioChunks = null; }
      if (audioChunks && !audioChunks.length) audioChunks = null;
    }
    if (cancel.v) throw new Error('cancel');

    var target = new Mux.ArrayBufferTarget();
    var muxer = new Mux.Muxer({
      target: target, fastStart: 'in-memory', firstTimestampBehavior: 'offset',
      video: { codec: 'avc', width: PW, height: PH },
      audio: audioChunks ? { codec: 'aac', numberOfChannels: 2, sampleRate: 48000 } : undefined
    });
    var failure = null;
    var venc = new VideoEncoder({ output: function (chunk, meta) { muxer.addVideoChunk(chunk, meta); }, error: function (e) { failure = e; } });
    venc.configure(vcfg);
    var total = Math.round(scene.D * FPS);
    try {
      for (var i = 0; i < total; i++) {
        if (cancel.v) throw new Error('cancel');
        if (failure) throw failure;
        scene.render(ctx, i / FPS);
        var frame = new VideoFrame(canvas, { timestamp: Math.round(i * 1e6 / FPS), duration: Math.round(1e6 / FPS) });
        venc.encode(frame, { keyFrame: i % (FPS * 2) === 0 });
        frame.close();
        if (i % 3 === 0) { progress(0.08 + 0.78 * (i / total), 'Creăm cadrele videoclipului…'); await tick(); }
        // coada encoderului ramane mica (un cadru 1080x1920 necomprimat are ~3 MB): asteptam evenimentul 'dequeue'
        while (venc.encodeQueueSize > 4) { await waitDequeue(venc); if (cancel.v) throw new Error('cancel'); if (failure) throw failure; }
      }
      progress(0.88, 'Finalizăm videoclipul…');
      await venc.flush();
      if (failure) throw failure;
    } finally { try { venc.close(); } catch (e) {} }

    if (audioChunks) audioChunks.forEach(function (a) { muxer.addAudioChunk(a.chunk, a.meta); });
    muxer.finalize();
    progress(0.97, 'Aproape gata…');
    return { blob: new Blob([target.buffer], { type: 'video/mp4' }), ext: 'mp4', mime: 'video/mp4', audio: !!audioChunks, how: 'webcodecs' };
  }

  // 2) MediaRecorder (timp real)
  function pickRecorderMime() {
    if (typeof MediaRecorder === 'undefined' || !HTMLCanvasElement.prototype.captureStream) return '';
    var list = ['video/mp4;codecs=avc1.640028,mp4a.40.2', 'video/mp4;codecs=avc1.42E01E,mp4a.40.2', 'video/mp4;codecs=avc1', 'video/mp4', 'video/webm;codecs=vp9,opus', 'video/webm;codecs=vp8,opus', 'video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'];
    for (var i = 0; i < list.length; i++) { try { if (MediaRecorder.isTypeSupported(list[i])) return list[i]; } catch (e) {} }
    return '';
  }
  async function encodeRecorder(scene, canvas, ctx, cancel, progress) {
    var mime = pickRecorderMime();
    if (!mime) throw new Error('no-recorder');
    // timp real: 720x1280 tine 30 fps pe mai multe device-uri decat 1080x1920
    if (canvas.width > 720) { canvas.width = 720; canvas.height = 1280; scene.setScale(720 / W); }
    var stream = canvas.captureStream(FPS), ac = null, src = null, audioOk = false;
    try {
      progress(0.04, 'Pregătim muzica…');
      var AC = window.AudioContext || window.webkitAudioContext, buf = AC ? await synthAudio(scene.D, scene.tOut, scene.voice) : null;
      if (buf && AC) {
        ac = new AC();
        // resume() poate sta nesfarsit daca browserul blocheaza sunetul -> nu asteptam mai mult de 1.2 s si mergem fara muzica
        await Promise.race([ac.resume().catch(function () {}), sleep(1200)]);
        if (ac.state === 'running') {
          var dest = ac.createMediaStreamDestination(); src = ac.createBufferSource(); src.buffer = buf; src.connect(dest);
          stream.addTrack(dest.stream.getAudioTracks()[0]); audioOk = true;
        } else { try { ac.close(); } catch (e) {} ac = null; }
      }
    } catch (e) { log('rec-audio', e); ac = null; src = null; audioOk = false; }
    var rec = new MediaRecorder(stream, { mimeType: mime, videoBitsPerSecond: SCALE < 1 ? 3500000 : 6000000, audioBitsPerSecond: 128000 });
    var chunks = []; rec.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
    var done = new Promise(function (res) { rec.onstop = res; });
    scene.render(ctx, 0);
    rec.start(250);
    if (src) { try { src.start(); } catch (e) { audioOk = false; } }
    var t0 = performance.now();
    await new Promise(function (resolve, reject) {
      var iv = setInterval(function () {
        if (cancel.v) { clearInterval(iv); reject(new Error('cancel')); return; }
        var t = (performance.now() - t0) / 1000;
        scene.render(ctx, Math.min(t, scene.D - 0.001));
        progress(0.08 + 0.85 * Math.min(1, t / scene.D), 'Înregistrăm videoclipul… (nu schimba fila)');
        if (t >= scene.D + 0.25) { clearInterval(iv); resolve(); }
      }, 1000 / FPS);
    }).catch(function (e) { try { rec.stop(); } catch (x) {} throw e; });
    rec.stop(); await done;
    try { if (ac) ac.close(); } catch (e) {}
    var type = (rec.mimeType || mime).split(';')[0];
    return { blob: new Blob(chunks, { type: type }), ext: /mp4/.test(type) ? 'mp4' : 'webm', mime: type, audio: audioOk, how: 'recorder' };
  }

  function canvasToBlob(canvas, type, q) { return new Promise(function (r) { try { canvas.toBlob(function (b) { r(b); }, type, q); } catch (e) { r(null); } }); }

  /* ------------------------------------------------------------------ orchestrare generare */
  async function generate(opts) {
    // opts: {palette, cancel, progress}
    var progress = opts.progress || function () {}, cancel = opts.cancel || { v: false };
    progress(0.01, 'Pregătim pozele produsului…');
    var d = opts.data, pal = opts.palette;
    await loadFonts();
    var logoUrl = findLogoUrl();
    var urls = d.images.slice(0, 5);
    var settled = await Promise.all(urls.map(function (u) { return loadImageAny(u, 1400); }));
    var logo = logoUrl ? await loadImage(logoUrl, 8000) : null;
    var imgs = settled.filter(Boolean);
    if (!imgs.length) throw new Error('no-images');
    var base = imgs.slice(0, 4).map(function (im) {
      var a = analyseImage(im), bg = 'rgb(' + a.rgb.join(',') + ')';
      var tex = a.uniform ? featherImage(trimToSubject(im, a.rgb), a.rgb) : im;
      return { img: tex, bg: bg, uniform: a.uniform, backdrop: a.uniform ? null : makeBackdrop(im) };
    });
    if (cancel.v) throw new Error('cancel');

    // ---- voce (optionala): cronologia videoclipului se potriveste cu durata reala a vorbirii
    var voiceSeg = null, voiceFailed = false, voicePlan = null, nShots = Math.max(3, base.length), outroLen = OUTRO;
    if (opts.voiceId) {
      progress(0.03, 'Pregătim vocea în română…');
      try { voiceSeg = await (opts.voiceP || loadVoice(d.handle, opts.voiceId)); }
      catch (ve) { voiceFailed = true; voiceSeg = null; log('voce esuata', ve); }
      if (cancel.v) throw new Error('cancel');
    }
    if (voiceSeg) {
      var hookStart = 0.25, mainStart = Math.max(SHOT + 0.1, hookStart + voiceSeg.hook.dur + 0.2);
      var mainEnd = mainStart + voiceSeg.main.dur, mainRate = 1, BEAT = SHOT / 4;
      // finalul incepe imediat dupa ce se termina partea despre produs (pe bataia muzicii), nu la capatul unei masuri intregi
      var tOutV = Math.max(3 * SHOT, Math.ceil((mainEnd + 0.3) / BEAT - 1e-6) * BEAT);
      if (tOutV > 5 * SHOT) { tOutV = 5 * SHOT; mainRate = Math.min(1.3, voiceSeg.main.dur / Math.max(1, tOutV - 0.3 - mainStart)); }
      nShots = Math.max(3, Math.ceil(tOutV / SHOT - 1e-6));
      var outroStart = tOutV + 0.15;
      outroLen = Math.max(OUTRO, 0.15 + voiceSeg.outro.dur + 0.4);
      voicePlan = [
        { buf: voiceSeg.hook.buf, off: voiceSeg.hook.off, dur: voiceSeg.hook.dur, gain: voiceSeg.hook.gain, start: hookStart, rate: 1 },
        { buf: voiceSeg.main.buf, off: voiceSeg.main.off, dur: voiceSeg.main.dur, gain: voiceSeg.main.gain, start: mainStart, rate: mainRate },
        { buf: voiceSeg.outro.buf, off: voiceSeg.outro.off, dur: voiceSeg.outro.dur, gain: voiceSeg.outro.gain, start: outroStart, rate: 1 }
      ];
    }
    var shots = [];
    for (var sk = 0; sk < nShots; sk++) shots.push(base[sk % base.length]);
    var scene = new Scene({ data: d, pal: pal, shots: shots, logo: logo, scale: SCALE, outroLen: outroLen, voice: voicePlan, tOut: voicePlan ? tOutV : 0 });

    var canvas = opts.canvas, ctx = canvas.getContext('2d');
    canvas.width = PW; canvas.height = PH;
    // poza (poster) - mereu
    var pc = document.createElement('canvas'); pc.width = PW; pc.height = PH;
    scene.render(pc.getContext('2d'), scene.tPoster);
    var posterBlob = await canvasToBlob(pc, 'image/png');
    scene.render(ctx, 0);

    var result = null, errors = [];
    try { result = await encodeWebCodecs(scene, canvas, ctx, cancel, progress); }
    catch (e) { if (e && e.message === 'cancel') throw e; errors.push(e); log('webcodecs esuat', e); }
    if (!result) {
      try { result = await encodeRecorder(scene, canvas, ctx, cancel, progress); }
      catch (e2) { if (e2 && e2.message === 'cancel') throw e2; errors.push(e2); log('recorder esuat', e2); }
    }
    return { video: result, poster: posterBlob, posterCanvas: pc, scene: scene, errors: errors, voiceUsed: !!(voicePlan && result && result.audio), voiceFailed: voiceFailed };
  }

  /* ------------------------------------------------------------------ link de distribuire (MP4 urcat pe serverul de retur) */
  function uploadApi() { return voiceApi().replace('story-voice', 'story-upload'); }
  // out.link = { status: 'pending'|'ready'|'failed', url, abort }
  function startUpload(out) {
    if (out.link) return out.link;
    var d = state.data, L = out.link = { status: 'pending', url: '', abort: null };
    L.promise = (async function () {
      for (var attempt = 0; attempt < 2; attempt++) {
        try {
          var c = new AbortController(); L.abort = function () { try { c.abort(); } catch (e) {} };
          var r = await fetch(uploadApi() + '?handle=' + encodeURIComponent(d.handle), {
            method: 'POST', mode: 'cors', credentials: 'omit', signal: c.signal,
            headers: { 'Content-Type': 'text/plain' },                      // "simple request": fara preflight
            body: out.video.blob.slice(0, out.video.blob.size, 'text/plain')
          });
          var j = await r.json();
          if (!r.ok || !j || !j.ok || !j.url) throw new Error('upload-' + r.status);
          L.status = 'ready'; L.url = j.url; track('tp_story_link', { item_id: d.handle }); break;
        } catch (e) {
          log('upload esuat', e);
          if (e && e.name === 'AbortError') { out.link = null; return L; }
          if (attempt === 0) await sleep(2500); else L.status = 'failed';
        }
      }
      refreshShareUi(out);
      return L;
    })();
    refreshShareUi(out);
    return L;
  }
  function scheduleUpload(out) {
    clearTimeout(state.upTimer);
    // doar cand se poate distribui fisierul (Web Share) si omul ramane pe rezultat (nu cand schimba stilul / inchide)
    if (!out || !out.video || out.video.ext !== 'mp4' || !out.canFile || out.link) return;
    state.upTimer = setTimeout(function () { if (state.modal && state.last === out) startUpload(out); }, 900);
  }
  function abortUploads() {
    clearTimeout(state.upTimer);
    var o = state.last;
    if (o && o.link && o.link.status === 'pending' && o.link.abort) o.link.abort();
  }
  function refreshShareUi(out) {
    var m = state.modal; if (!m || state.last !== out) return;
    var b = m.querySelector('#tps-share'), sub = m.querySelector('#tps-share-sub'); if (!b || !sub) return;
    var L = out.link, needLink = !!(out.canFile && out.video && out.video.ext === 'mp4');
    var busy = needLink && (!L || L.status === 'pending');
    b.disabled = busy; b.setAttribute('aria-busy', String(busy));
    sub.textContent = busy ? 'Se pregătește link-ul de cumpărare…' : (out.canFile ? 'Video + link cu buton de cumpărare' : 'Se salvează videoclipul, apoi îl încarci tu');
  }

  /* ------------------------------------------------------------------ interfata */
  var CSS = [
    '.tps-open{all:unset;box-sizing:border-box;display:flex;align-items:center;gap:14px;width:100%;margin:14px 0 6px;padding:11px 18px 11px 12px;border-radius:999px!important;cursor:pointer;color:#fff;background:linear-gradient(100deg,#ff8a1f 0%,#ff4f9a 100%);box-shadow:0 10px 24px -12px rgba(255,79,154,.75);position:relative;overflow:hidden;-webkit-tap-highlight-color:transparent;touch-action:manipulation;font-family:inherit}',
    '.tps-open:focus-visible{outline:3px solid #111;outline-offset:3px}',
    '.tps-open::after{content:"";position:absolute;inset:0;background:linear-gradient(110deg,transparent 35%,rgba(255,255,255,.38) 50%,transparent 65%);transform:translateX(-120%);animation:tpsShine 5.5s ease-in-out 1.5s infinite}',
    '@keyframes tpsShine{0%,70%{transform:translateX(-120%)}100%{transform:translateX(120%)}}',
    '.tps-open__ic{flex:0 0 46px;height:46px;border-radius:50%;background:rgba(255,255,255,.24);display:grid;place-items:center}',
    '.tps-open__ic svg{width:24px;height:24px;fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}',
    '.tps-open__t{display:flex;flex-direction:column;min-width:0;line-height:1.2;text-align:left}',
    '.tps-open__t b{font-size:19px;font-weight:800;letter-spacing:.005em}',
    '.tps-open__t span{font-size:15px;font-weight:600;opacity:.96;margin-top:2px}',
    '.tps-ov{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(14,10,24,.74);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);opacity:0;transition:opacity .22s;font-family:inherit;color:#1b1b1f}',
    '.tps-ov.is-in{opacity:1}',
    '.tps-ov *{box-sizing:border-box}',
    '.tps-panel{position:relative;width:min(980px,100%);max-height:calc(100vh - 36px);max-height:calc(100dvh - 36px);overflow:auto;overscroll-behavior:contain;background:#fff;border-radius:28px;padding:26px;box-shadow:0 40px 100px -30px rgba(0,0,0,.6);transform:translateY(16px) scale(.98);transition:transform .28s cubic-bezier(.2,.8,.2,1)}',
    '.tps-ov.is-in .tps-panel{transform:none}',
    '.tps-x{all:unset;position:absolute;top:12px;right:12px;width:48px;height:48px;border-radius:50%!important;display:grid;place-items:center;cursor:pointer;background:#f1f1f3;color:#1b1b1f;z-index:3;-webkit-tap-highlight-color:transparent}',
    '.tps-x:hover{background:#e4e4e8}.tps-x:focus-visible{outline:3px solid #111;outline-offset:2px}',
    '.tps-x svg{width:22px;height:22px;stroke:currentColor;stroke-width:2.4;fill:none;stroke-linecap:round}',
    '.tps-grid{display:grid;grid-template-columns:minmax(0,340px) minmax(0,1fr);gap:30px;align-items:center}',
    '.tps-stage{position:relative;width:100%;max-width:340px;margin:0 auto}',
    '.tps-frame{position:relative;width:100%;aspect-ratio:9/16;border-radius:22px;overflow:hidden;background:#20142e;box-shadow:0 22px 50px -22px rgba(30,10,60,.6)}',
    '.tps-frame canvas,.tps-frame video,.tps-frame img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;background:#20142e}',
    '.tps-side h2{margin:0 44px 8px 0;font-size:28px;line-height:1.15;font-weight:800;letter-spacing:-.01em}',
    '.tps-sub{margin:0 0 18px;font-size:18px;line-height:1.45;color:#3a3a44}',
    '.tps-bar{height:12px;border-radius:99px;background:#eee;overflow:hidden;margin:6px 0 10px}',
    '.tps-bar i{display:block;height:100%;width:0;border-radius:99px;background:linear-gradient(90deg,#ff8a1f,#ff4f9a);transition:width .25s}',
    '.tps-msg{font-size:18px;font-weight:700;color:#1b1b1f;margin:0 0 6px;min-height:26px}',
    '.tps-note{font-size:16px;color:#5a5a66;margin:0}',
    '.tps-actions{display:flex;flex-direction:column;gap:12px;margin:4px 0 4px}',
    '.tps-btn{all:unset;box-sizing:border-box;display:flex;align-items:center;justify-content:center;gap:12px;min-height:58px;padding:12px 22px;border-radius:999px!important;font-size:19px;font-weight:800;line-height:1.15;text-align:center;cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation;font-family:inherit;transition:transform .15s,box-shadow .15s,background .15s}',
    '.tps-btn svg{width:24px;height:24px;flex:0 0 auto;fill:none;stroke:currentColor;stroke-width:2.1;stroke-linecap:round;stroke-linejoin:round}',
    '.tps-btn:active{transform:scale(.97)}.tps-btn:focus-visible{outline:3px solid #111;outline-offset:3px}',
    '.tps-two{display:flex;flex-direction:column;align-items:center;gap:2px}.tps-two small{font-size:15px;font-weight:600;opacity:.95}',
    '.tps-btn[disabled]{opacity:.65;cursor:progress}',
    '.tps-btn--main{color:#fff;background:linear-gradient(100deg,#ff8a1f,#ff4f9a);box-shadow:0 12px 26px -14px rgba(255,79,154,.9)}',
    '.tps-btn--alt{color:#1b1b1f;background:#fff;border:2.5px solid #1b1b1f!important}.tps-btn--alt:hover{background:#f6f6f8}',
    '.tps-btn--fb{color:#fff;background:#1877f2}.tps-btn--fb:hover{background:#1468d6}',
    '.tps-btn--wa{color:#fff;background:#1fa855}.tps-btn--wa:hover{background:#198f48}',
    '.tps-row{display:flex;gap:12px;flex-wrap:wrap}.tps-row .tps-btn{flex:1 1 200px}',
    '.tps-styles{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin:14px 0 4px;font-size:17px;font-weight:700}',
    '.tps-chip{all:unset;box-sizing:border-box;display:inline-flex;align-items:center;gap:9px;min-height:46px;padding:7px 16px 7px 8px;border-radius:999px!important;border:2.5px solid #d9d9df!important;font-size:16px;font-weight:700;cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.tps-chip i{width:28px;height:28px;border-radius:50%;display:block}',
    '.tps-chip[aria-pressed=true]{border-color:#1b1b1f!important;background:#f4f4f6}.tps-chip:focus-visible{outline:3px solid #111;outline-offset:2px}',
    '.tps-hint{margin:14px 0 0;padding:14px 16px;border-radius:16px;background:#fff6ea;color:#5b3200;font-size:17px;line-height:1.5}',
    '.tps-hint b{font-weight:800}',
    '.tps-link{all:unset;cursor:pointer;color:#1b1b1f;text-decoration:underline;font-size:16px;font-weight:700;margin-top:12px;display:inline-block;-webkit-tap-highlight-color:transparent}',
    '.tps-err{margin:10px 0 0;padding:14px 16px;border-radius:16px;background:#fdecec;color:#8a1022;font-size:17px;line-height:1.45;font-weight:600}',
    '.tps-ovl{position:absolute;left:0;right:0;bottom:14px;display:flex;justify-content:center;pointer-events:none}.tps-ovl span{background:rgba(20,10,35,.78);color:#fff;font-weight:800;font-size:18px;padding:8px 18px;border-radius:99px}',
    '.tps-opts{display:flex;flex-direction:column;gap:12px;margin:2px 0 14px}',
    '.tps-opt{all:unset;box-sizing:border-box;position:relative;display:flex;align-items:center;gap:14px;padding:16px 18px;border-radius:20px!important;border:2.5px solid #d9d9df!important;background:#fff;cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation;font-family:inherit;color:#1b1b1f}',
    '.tps-opt:focus-visible{outline:3px solid #111;outline-offset:3px}',
    '.tps-opt[aria-checked=true]{border-color:#ff4f9a!important;background:#fff4f8;box-shadow:0 8px 22px -14px rgba(255,79,154,.9)}',
    '.tps-opt__ic{flex:0 0 48px;height:48px;border-radius:50%;background:#f1f1f3;display:grid;place-items:center}',
    '.tps-opt[aria-checked=true] .tps-opt__ic{background:linear-gradient(100deg,#ff8a1f,#ff4f9a);color:#fff}',
    '.tps-opt__ic svg{width:26px;height:26px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}',
    '.tps-opt__t{display:flex;flex-direction:column;gap:3px;min-width:0;line-height:1.25}',
    '.tps-opt__t b{font-size:19px;font-weight:800}',
    '.tps-opt__t small{font-size:16px;font-weight:500;color:#4a4a55}',
    '.tps-opt em{position:absolute;top:-11px;right:16px;font-style:normal;font-size:13px;font-weight:800;letter-spacing:.03em;text-transform:uppercase;color:#fff;background:#ff4f9a;padding:3px 10px;border-radius:99px}',
    '.tps-chip--t{padding:7px 16px!important}',
    '.tps-ph{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:24px;text-align:center;color:#fff;background:linear-gradient(160deg,#ff8a1f,#ff4f9a)}',
    '.tps-ph b{font-size:22px;font-weight:800}.tps-ph span{font-size:16px;font-weight:600;opacity:.95}',
    '.tps-toast{position:absolute;left:50%;bottom:18px;transform:translateX(-50%);background:#1b1b1f;color:#fff;padding:12px 20px;border-radius:999px;font-size:17px;font-weight:700;z-index:5;white-space:nowrap}',
    '@media (max-width:760px){.tps-ov{padding:0;align-items:flex-end}.tps-panel{width:100%;max-height:100vh;max-height:100dvh;border-radius:26px 26px 0 0;padding:18px 16px 22px}.tps-grid{grid-template-columns:1fr;gap:16px}.tps-stage{max-width:none}.tps-frame{height:40vh;height:40dvh;width:22.5vh;width:22.5dvh;margin:0 auto}.tps-side h2{font-size:23px;margin-right:50px}.tps-sub{font-size:17px;margin-bottom:12px}.tps-row .tps-btn{flex-basis:100%}.tps-styles{gap:8px}.tps-chip{padding:6px 12px 6px 6px;font-size:15px;gap:7px}.tps-chip i{width:24px;height:24px}}',
    '@media (prefers-reduced-motion:reduce){.tps-open::after{animation:none}.tps-ov,.tps-panel{transition:none}}'
  ].join('\n');

  var ICON_FILM = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="3"/><path d="M10 9.2v5.6l4.8-2.8z" fill="#fff" stroke="none"/></svg>';
  var ICON_SHARE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 15V3m0 0L7.5 7.5M12 3l4.5 4.5"/><path d="M5 12v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>';
  var ICON_DL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12m0 0l-4.5-4.5M12 15l4.5-4.5"/><path d="M5 19h14"/></svg>';
  var ICON_MIC = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7"/></svg>';
  var ICON_NOTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18V6l10-2v12"/><circle cx="6.5" cy="18" r="2.5"/><circle cx="16.5" cy="16" r="2.5"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l12-7.5z" style="fill:currentColor;stroke:none"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  var state = { data: null, dataP: null, running: false, cancel: null, modal: null, urls: [], palette: 0, opener: null, last: null, cache: {}, mode: 'voice', voice: 'f', voiceP: {}, upTimer: 0, pushed: false };
  try { var _pm = localStorage.getItem('tps_mode'), _pv = localStorage.getItem('tps_voice'); if (_pm === 'music' || _pm === 'voice') state.mode = _pm; if (_pv === 'm' || _pv === 'f') state.voice = _pv; } catch (e) {}
  function savePref() { try { localStorage.setItem('tps_mode', state.mode); localStorage.setItem('tps_voice', state.voice); } catch (e) {} }
  function cacheKey() { return state.palette + '|' + state.mode + '|' + (state.mode === 'voice' ? state.voice : '-'); }

  function injectCss() {
    if (document.getElementById('tps-css')) return;
    var st = document.createElement('style'); st.id = 'tps-css'; st.textContent = CSS; document.head.appendChild(st);
  }
  function h(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function buildButton() {
    return h('<button type="button" class="tps-open" id="tps-open" aria-haspopup="dialog"><span class="tps-open__ic">' + ICON_FILM + '</span><span class="tps-open__t"><b>Fă un video pentru Story</b><span>Gata în câteva secunde, cu voce și muzică</span></span></button>');
  }

  function mountButton() {
    if (document.getElementById('tps-open')) return true;
    var anchor = document.querySelector('.tp-pdp-copy ul.tp-trust-row') || document.querySelector('.tp-pdp-copy .tp-trust-row');
    var btn = buildButton();
    if (anchor) { anchor.insertAdjacentElement('afterend', btn); }
    else {
      var form = document.querySelector('.tp-pdp-copy form[action*="/cart/add"], form[action*="/cart/add"]');
      if (!form) return false;
      form.insertAdjacentElement('afterend', btn);
    }
    btn.addEventListener('click', function () { openModal(btn); });
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) { btn.addEventListener(ev, prefetch, { once: true, passive: true }); });
    return true;
  }

  // la hover / focus / atingere incepem sa incarcam datele, fonturile si muxer-ul: generarea porneste apoi mai repede
  var _prefetched = false;
  function prefetch() {
    if (_prefetched) return; _prefetched = true;
    try {
      if (!state.data && !state.dataP) state.dataP = loadProduct().then(function (d) { state.data = d; return d; }).catch(function () { state.dataP = null; });
      loadFonts();
      if (typeof VideoEncoder !== 'undefined') loadMux().catch(function () {});
    } catch (e) {}
  }

  function revoke() { state.urls.forEach(function (u) { try { URL.revokeObjectURL(u); } catch (e) {} }); state.urls = []; }

  function onPop() { if (state.modal && state.pushed) { state.pushed = false; closeModal(true); } }
  function closeModal(fromPop) {
    if (!state.modal) return;
    abortUploads();
    if (state.pushed && fromPop !== true) { state.pushed = false; try { history.back(); } catch (e) {} }
    if (state.cancel) state.cancel.v = true;
    var m = state.modal; state.modal = null;
    m.classList.remove('is-in');
    document.removeEventListener('keydown', onKey, true);
    window.removeEventListener('popstate', onPop);
    setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); revoke(); }, 230);
    document.documentElement.style.overflow = state.prevOverflow || '';
    state.running = false;
    if (state.opener && state.opener.focus) { try { state.opener.focus({ preventScroll: true }); } catch (e) {} }
  }
  function onKey(e) {
    if (!state.modal) return;
    if (e.key === 'Escape') { e.stopPropagation(); closeModal(); return; }
    if (e.key === 'Tab') {
      var f = state.modal.querySelectorAll('button:not([disabled]):not([hidden]), a[href], video[controls]');
      f = [].filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function toast(text) {
    if (!state.modal) return;
    var t = h('<div class="tps-toast" role="status">' + esc(text) + '</div>');
    state.modal.querySelector('.tps-panel').appendChild(t);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2200);
  }

  async function openModal(opener) {
    if (state.modal) return;
    injectCss();
    state.opener = opener || null;
    state.prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var m = h('<div class="tps-ov" role="dialog" aria-modal="true" aria-labelledby="tps-h"><div class="tps-panel">' +
      '<button type="button" class="tps-x" aria-label="Închide">' + ICON_X + '</button>' +
      '<div class="tps-grid"><div class="tps-stage"><div class="tps-frame" id="tps-frame"></div></div>' +
      '<div class="tps-side"><h2 id="tps-h">Creăm videoclipul tău…</h2>' +
      '<p class="tps-sub" id="tps-sub"></p>' +
      '<div id="tps-choice" hidden>' +
        '<div class="tps-opts" role="radiogroup" aria-label="Sunetul videoclipului">' +
          '<button type="button" class="tps-opt" role="radio" data-mode="voice"><span class="tps-opt__ic">' + ICON_MIC + '</span><span class="tps-opt__t"><b>Cu voce în română</b><small>Un narator spune produsul și prețul, cu muzică în fundal</small></span><em>Recomandat</em></button>' +
          '<button type="button" class="tps-opt" role="radio" data-mode="music"><span class="tps-opt__ic">' + ICON_NOTE + '</span><span class="tps-opt__t"><b>Doar cu muzică</b><small>Fără voce, doar muzica de fundal</small></span></button>' +
        '</div>' +
        '<div class="tps-styles" id="tps-voices" role="group" aria-label="Alege vocea">Voce: ' +
          '<button type="button" class="tps-chip" data-voice="f" aria-pressed="false"><i style="background:linear-gradient(135deg,#ff8a1f,#ff4f9a)"></i>Femeie</button>' +
          '<button type="button" class="tps-chip" data-voice="m" aria-pressed="false"><i style="background:linear-gradient(135deg,#1f78e6,#13b3a3)"></i>Bărbat</button>' +
        '</div>' +
        '<div class="tps-actions"><button type="button" class="tps-btn tps-btn--main" id="tps-go">' + ICON_PLAY + 'Creează videoclipul</button></div>' +
      '</div>' +
      '<div id="tps-prog"><div class="tps-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><i></i></div><p class="tps-msg" id="tps-msg" aria-live="polite">Pregătim pozele…</p><p class="tps-note">Durează câteva secunde. Poți lăsa fereastra deschisă.</p></div>' +
      '<div id="tps-res" hidden></div>' +
      '<p class="tps-err" id="tps-err" role="alert" hidden></p>' +
      '</div></div></div></div>');
    document.body.appendChild(m);
    state.modal = m;
    requestAnimationFrame(function () { m.classList.add('is-in'); });
    m.addEventListener('click', function (e) { if (e.target === m) closeModal(); });
    m.querySelector('.tps-x').addEventListener('click', function () { closeModal(); });
    document.addEventListener('keydown', onKey, true);
    try { history.pushState({ tpsModal: 1 }, '', location.href); state.pushed = true; window.addEventListener('popstate', onPop); } catch (e) { state.pushed = false; }
    try { m.querySelector('.tps-x').focus({ preventScroll: true }); } catch (e) {}
    track('tp_story_open', { item_id: handleFromPath() });
    m.querySelector('#tps-choice').addEventListener('click', onChoiceClick);
    if (state.cache[cacheKey()]) run(); else showChoice();
  }

  function frameWait() {
    var f = state.modal && state.modal.querySelector('#tps-frame'); if (!f) return;
    f.innerHTML = '<div class="tps-ph"><b>Previzualizare</b><span>Videoclipul tău apare aici după creare</span></div>';
  }
  function syncChoice() {
    var m = state.modal; if (!m) return;
    [].forEach.call(m.querySelectorAll('.tps-opt'), function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-mode') === state.mode)); });
    [].forEach.call(m.querySelectorAll('#tps-voices .tps-chip'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-voice') === state.voice)); });
    m.querySelector('#tps-voices').hidden = state.mode !== 'voice';
  }
  // pornim incarcarea vocii din timp (cat se decide omul), ca generarea sa nu astepte dupa server
  function prewarmVoice(v) {
    if (state.voiceP[v]) return state.voiceP[v];
    var pr = loadVoice(handleFromPath(), v);
    state.voiceP[v] = pr;
    pr.catch(function () { if (state.voiceP[v] === pr) state.voiceP[v] = null; });
    return pr;
  }
  function showChoice() {
    var m = state.modal; if (!m) return;
    m.querySelector('#tps-h').textContent = 'Cum vrei videoclipul?';
    m.querySelector('#tps-sub').textContent = 'Alege sunetul. Pozele, prețul și mărimile se pun automat.';
    m.querySelector('#tps-prog').hidden = true; m.querySelector('#tps-res').hidden = true; m.querySelector('#tps-err').hidden = true;
    m.querySelector('#tps-choice').hidden = false;
    frameWait(); syncChoice();
    if (state.mode === 'voice') prewarmVoice(state.voice);
    var sel = m.querySelector('.tps-opt[aria-checked="true"]'); if (sel) { try { sel.focus({ preventScroll: true }); } catch (e) {} }
  }
  function onChoiceClick(e) {
    var t = e.target.closest ? e.target.closest('.tps-opt,[data-voice],#tps-go') : null; if (!t) return;
    if (t.classList.contains('tps-opt')) { state.mode = t.getAttribute('data-mode'); savePref(); syncChoice(); if (state.mode === 'voice') prewarmVoice(state.voice); }
    else if (t.hasAttribute('data-voice')) { state.voice = t.getAttribute('data-voice'); savePref(); syncChoice(); prewarmVoice(state.voice); }
    else if (t.id === 'tps-go') { track('tp_story_go', { mode: state.mode, voice: state.voice }); run(); }
  }

  function setProgress(p, msg) {
    var m = state.modal; if (!m) return;
    var bar = m.querySelector('.tps-bar'); if (!bar) return;
    var pct = Math.round(clamp01(p) * 100);
    bar.firstChild.style.width = pct + '%'; bar.setAttribute('aria-valuenow', String(pct));
    var pc = m.querySelector('#tps-pct'); if (pc) pc.textContent = pct + '%';
    var t = m.querySelector('#tps-msg'); if (t && msg) t.textContent = msg;
  }

  function showError(text) {
    var m = state.modal; if (!m) return;
    var e = m.querySelector('#tps-err'); e.textContent = text; e.hidden = false;
  }

  async function run() {
    if (state.running) return; state.running = true;
    var m = state.modal, frame = m.querySelector('#tps-frame');
    frame.innerHTML = '';
    var cancel = { v: false }; state.cancel = cancel;
    var canvas = document.createElement('canvas'); frame.appendChild(canvas);
    frame.appendChild(h('<div class="tps-ovl" aria-hidden="true"><span id="tps-pct">0%</span></div>'));
    m.querySelector('#tps-choice').hidden = true;
    m.querySelector('#tps-prog').hidden = false; m.querySelector('#tps-res').hidden = true; m.querySelector('#tps-err').hidden = true;
    m.querySelector('#tps-h').textContent = 'Creăm videoclipul tău…';
    m.querySelector('#tps-sub').textContent = 'Transformăm pozele produsului într-un videoclip scurt, gata de postat în Story sau pe Facebook.';
    setProgress(0.01, 'Pregătim pozele…');
    try {
      var cached = state.cache[cacheKey()];
      if (cached) { state.last = cached; showResult(cached); return; }
      if (!state.data) { if (state.dataP) await state.dataP; if (!state.data) state.data = await loadProduct(); }
      // paza: daca ceva se blocheaza (retea, codec), nu lasam omul sa astepte la nesfarsit
      var wd = setTimeout(function () { cancel.timeout = true; cancel.v = true; }, 150000);
      var out;
      var wantVoice = state.mode === 'voice' ? state.voice : null;
      try { out = await generate({ data: state.data, palette: PALETTES[state.palette], canvas: canvas, cancel: cancel, progress: setProgress, voiceId: wantVoice, voiceP: wantVoice ? prewarmVoice(wantVoice) : null }); }
      catch (ge) { if (cancel.timeout) throw new Error('timeout'); throw ge; }
      finally { clearTimeout(wd); }
      if (cancel.v || !state.modal) return;
      state.last = out;
      if (out.video) state.cache[state.palette + '|' + (out.voiceUsed ? 'voice|' + state.voice : 'music|-')] = out;
      showResult(out);
    } catch (e) {
      if (e && e.message === 'cancel') return;
      log('eroare', e);
      track('tp_story_error', { message: String(e && e.message || e).slice(0, 80) });
      if (!state.modal) return;
      m.querySelector('#tps-h').textContent = 'Nu am putut crea videoclipul';
      m.querySelector('#tps-prog').hidden = true;
      showError(e && e.message === 'no-images'
        ? 'Nu am putut încărca pozele produsului. Verifică conexiunea la internet și încearcă din nou.'
        : (e && e.message === 'timeout' ? 'Durează prea mult pe acest dispozitiv. Închide și încearcă din nou, sau trimite link-ul produsului.' : 'Ceva nu a mers la crearea videoclipului. Încearcă din nou; poți trimite și link-ul produsului.'));
      showResult({ video: null, poster: null, errors: [e] }, true);
    } finally { state.running = false; }
  }

  function dlName(ext) { return 'TotalPantofi-' + (state.data ? state.data.handle.slice(0, 60) : 'produs') + '.' + ext; }

  function showResult(out, failed) {
    var m = state.modal; if (!m) return;
    var d = state.data || { title: '', price: 0, url: location.href, handle: '' };
    var frame = m.querySelector('#tps-frame'), res = m.querySelector('#tps-res');
    var video = out.video, posterUrl = out.poster ? URL.createObjectURL(out.poster) : '';
    if (posterUrl) state.urls.push(posterUrl);
    var file = null, vUrl = '';
    if (video) {
      vUrl = URL.createObjectURL(video.blob); state.urls.push(vUrl);
      try { file = new File([video.blob], dlName(video.ext), { type: video.mime }); } catch (e) {}
      frame.innerHTML = '';
      var v = document.createElement('video');
      v.src = vUrl; v.muted = true; v.loop = true; v.playsInline = true; v.controls = true; v.autoplay = true; v.setAttribute('playsinline', ''); v.setAttribute('aria-label', 'Previzualizare videoclip');
      if (posterUrl) v.poster = posterUrl;
      frame.appendChild(v);
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    } else if (posterUrl) {
      frame.innerHTML = ''; var im = document.createElement('img'); im.src = posterUrl; im.alt = 'Imagine pentru Story'; frame.appendChild(im);
      try { file = new File([out.poster], dlName('png'), { type: 'image/png' }); } catch (e) {}
    }
    var fileUrl = video ? vUrl : posterUrl;

    var canFile = false;
    try { canFile = !!(file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })); } catch (e) {}
    var productUrl = shareUrl(d, 'story');
    out.canFile = canFile;
    var shareText = 'Uite ce produs am găsit pe ' + STORE + '! 🛍️\n' + d.title + ' – ' + fmtPrice(d.price) + ' lei';
    var kind = video ? 'videoclipul' : 'imaginea';

    var html = '<div class="tps-actions">';
    if (file) {
      html += '<button type="button" class="tps-btn tps-btn--main" id="tps-share" data-a="share">' + ICON_SHARE + '<span class="tps-two"><b>' + (video ? 'Distribuie' : 'Distribuie imaginea') + '</b><small id="tps-share-sub"></small></span></button>';
      html += '<a class="tps-btn tps-btn--alt" data-a="dl" href="' + fileUrl + '" download="' + esc(file.name) + '">' + ICON_DL + 'Salvează ' + kind + '</a>';
    } else {
      html += '<button type="button" class="tps-btn tps-btn--main" id="tps-share" data-a="retry">' + ICON_PLAY + 'Încearcă din nou</button>';
    }
    html += '</div>';
    var activeMode = out.voiceUsed ? 'voice' : 'music';
    if (video) {
      html += '<div class="tps-styles" role="group" aria-label="Sunetul videoclipului">Sunet: ' +
        '<button type="button" class="tps-chip tps-chip--t" data-mode="voice" aria-pressed="' + (activeMode === 'voice') + '">Voce + muzică</button>' +
        '<button type="button" class="tps-chip tps-chip--t" data-mode="music" aria-pressed="' + (activeMode === 'music') + '">Doar muzică</button></div>';
      if (activeMode === 'voice') {
        html += '<div class="tps-styles" role="group" aria-label="Alege vocea">Voce: ' +
          '<button type="button" class="tps-chip" data-voice="f" aria-pressed="' + (state.voice === 'f') + '"><i style="background:linear-gradient(135deg,#ff8a1f,#ff4f9a)"></i>Femeie</button>' +
          '<button type="button" class="tps-chip" data-voice="m" aria-pressed="' + (state.voice === 'm') + '"><i style="background:linear-gradient(135deg,#1f78e6,#13b3a3)"></i>Bărbat</button></div>';
      }
      html += '<div class="tps-styles" role="group" aria-label="Alege stilul">Stil: ' + PALETTES.map(function (p, i) {
        return '<button type="button" class="tps-chip" data-style="' + i + '" aria-pressed="' + (i === state.palette) + '"><i style="background:linear-gradient(135deg,' + p.c1 + ',' + p.c2 + ')"></i>' + p.name + '</button>';
      }).join('') + '</div>';
      html += '<p class="tps-hint"><b>Distribuie</b> trimite videoclipul în aplicația aleasă (Story, Reel, postare, mesaj), cu un link: cine îl apasă vede videoclipul cu un buton mare de cumpărare și ajunge direct la produs. <b>Salvează videoclipul</b> ca să-l postezi tu, doar ca video. Link-ul produsului se copiază automat, pentru stickerul „Link” din Story.</p>';
      if (!video.audio) html += '<p class="tps-note" style="margin-top:10px">Videoclipul este fără sunet pe acest dispozitiv.</p>';
      if (out.voiceFailed || (state.mode === 'voice' && !out.voiceUsed && video.audio)) html += '<p class="tps-note" style="margin-top:10px">Nu am putut încărca vocea acum, așa că videoclipul are doar muzică. Apasă „Voce + muzică” ca să încerci din nou.</p>';
      if (IN_APP) html += '<p class="tps-note" style="margin-top:10px">Ești în browserul din aplicație (Facebook / Instagram). Dacă salvarea nu merge, deschide pagina în Chrome sau Safari.</p>';
      if (video.ext === 'webm') html += '<p class="tps-note" style="margin-top:10px">Browserul tău a creat un fișier .webm. Pentru Facebook/Instagram e mai sigur să deschizi pagina în Chrome sau Safari.</p>';
    } else if (file) {
      html += '<p class="tps-hint">Browserul tău nu poate crea video, așa că ți-am pregătit o <b>imagine</b> pentru Story. Pentru videoclip deschide pagina în Chrome sau Safari.</p>';
    }
    res.innerHTML = html;
    res.hidden = false;
    m.querySelector('#tps-prog').hidden = true;
    m.querySelector('#tps-h').textContent = failed ? 'Nu am putut crea videoclipul' : (video ? 'Videoclipul tău e gata!' : 'Imaginea ta e gata!');
    m.querySelector('#tps-sub').textContent = failed ? 'Încearcă din nou. Dacă nu merge, deschide pagina în Chrome sau Safari.' : (video && video.audio ? (out.voiceUsed ? 'Apasă pe difuzorul din player ca să auzi vocea și muzica.' : 'Apasă pe difuzorul din player ca să auzi muzica.') : 'Distribuie-l prietenilor și arată ce ai ales.');

    function copyText(t) {
      return (navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(t) : Promise.reject(new Error('nu'))).then(function () { return true; }, function () {
        try { var ta = document.createElement('textarea'); ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); var ok = document.execCommand('copy'); document.body.removeChild(ta); return ok; } catch (e2) { return false; }
      });
    }
    function saveFile() {
      try { var a = document.createElement('a'); a.href = fileUrl; a.download = file.name; a.style.display = 'none'; document.body.appendChild(a); a.click(); setTimeout(function () { if (a.parentNode) a.parentNode.removeChild(a); }, 500); } catch (e) {}
    }
    res.onclick = function (e) {
      var t = e.target.closest('[data-a],[data-style],[data-mode],[data-voice]'); if (!t) return;
      if (t.hasAttribute('data-style')) { state.palette = +t.getAttribute('data-style'); abortUploads(); revoke(); run(); return; }
      if (t.hasAttribute('data-mode')) { state.mode = t.getAttribute('data-mode'); savePref(); abortUploads(); revoke(); run(); return; }
      if (t.hasAttribute('data-voice')) { state.voice = t.getAttribute('data-voice'); savePref(); abortUploads(); revoke(); run(); return; }
      var a = t.getAttribute('data-a');
      if (a === 'retry') { e.preventDefault(); revoke(); run(); return; }
      if (a === 'dl') { track('tp_story_share', { method: video ? 'download' : 'download_png', item_id: d.handle }); toast('Se salvează…'); return; }
      if (a !== 'share') return;
      e.preventDefault();
      // MEREU fisierul video (nu link): Web Share cu fisier; fara el (ex. PC) salvam videoclipul si il incarci tu in aplicatie
      if (canFile) {
        try { copyText(productUrl); } catch (x) {}   // link-ul produsului in clipboard, pentru stickerul "Link" din Story
        var L = out.link, pageUrl = L && L.status === 'ready' ? L.url : '';
        // fisierul video + link catre pagina cu buton de cumparare (daca linkul n-a putut fi creat: linkul produsului)
        var text2 = shareText + '\n' + (pageUrl ? 'Vezi videoclipul și cumpără: ' + pageUrl : productUrl);
        var pr2;
        try { pr2 = navigator.share({ files: [file], title: d.title, text: text2 }); } catch (se) { pr2 = Promise.reject(se); }
        Promise.resolve(pr2).then(function () { track('tp_story_share', { method: pageUrl ? 'web_share_file_link' : 'web_share_file', item_id: d.handle }); }, function (er) {
          if (er && er.name === 'AbortError') return;
          saveFile(); toast('Distribuirea nu s-a deschis. Videoclipul s-a salvat: încarcă-l tu.');
        });
      } else {
        saveFile(); toast('Videoclipul s-a salvat. Încarcă-l acum în Facebook, Instagram sau WhatsApp.');
        track('tp_story_share', { method: 'download_share', item_id: d.handle });
      }
    };
    refreshShareUi(out);
    var first = res.querySelector('.tps-btn:not([disabled])') || res.querySelector('.tps-btn'); if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    scheduleUpload(out);
  }

  /* ------------------------------------------------------------------ pornire */
  function boot() {
    injectCss();
    var tries = 0;
    (function attempt() {
      if (mountButton()) { watch(); return; }
      if (tries++ < 40) setTimeout(attempt, 250);
    })();
  }
  function watch() {
    // daca tema re-randeaza coloana de produs si butonul dispare, il punem la loc (max. 60 s, fara bucle)
    var t0 = Date.now(), pend = false;
    var mo = new MutationObserver(function () {
      if (Date.now() - t0 > 60000) { mo.disconnect(); return; }
      if (pend || document.getElementById('tps-open')) return;
      pend = true; setTimeout(function () { pend = false; try { mountButton(); } catch (e) {} }, 200);
    });
    var root = document.querySelector('.tp-pdp') || document.body;
    mo.observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.TPStory = { version: VERSION, open: function () { openModal(document.getElementById('tps-open')); } };
  if (DEBUG) window.__tpStoryDebug = { Scene: Scene, generate: generate, loadProduct: loadProduct, PALETTES: PALETTES, synthAudio: synthAudio, state: state, loadFonts: loadFonts, loadImageAny: loadImageAny, analyseImage: analyseImage, PW: PW, PH: PH };
})();
